const AR_NOT_AVAILABLE_MESSAGE = {
  type: "p",
  text: "هذا المحتوى لم يتوفر باللغة العربية بعد"
};

function hasArabicContent(doc) {
  if (!doc?.items || doc.items.length === 0) return false;

  return doc.items.some(
    item => item.text && item.text.trim().length > 0
  );
}

export const policiesContent = {

  
  ar: [
    {
      title: `الحوكمة والإدارة`,
      slug: `governance-administration`,
      docs: [
        {
          id: `adequate-filing-system`,
          title: `نظام حفظ الملفات`,
          items: [
            {
              type: `p`,
              text: `بسم الله الرحمن الرحيم`
            },
            {
              type: `p`,
              text: `منظمة الخلد للاعمار والتنمية`
            },
            {
              type: `p`,
              text: ``
            },
            {
              type: `p`,
              text: ``
            },
            {
              type: `p`,
              text: ``
            },
            {
              type: `p`,
              text: ``
            },
            {
              type: `li`,
              text: ``
            },
            {
              type: `li`,
              text: ``
            },
            {
              type: `li`,
              text: ``
            },
            {
              type: `li`,
              text: ``
            },
            {
              type: `li`,
              text: ``
            },
            {
              type: `p`,
              text: ``
            },
            {
              type: `li`,
              text: ``
            },
            {
              type: `li`,
              text: ``
            },
            {
              type: `li`,
              text: ``
            },
            {
              type: `li`,
              text: ``
            },
            {
              type: `li`,
              text: ``
            },
            {
              type: `p`,
              text: ``
            },
            {
              type: `li`,
              text: ``
            },
            {
              type: `li`,
              text: ``
            },
            {
              type: `li`,
              text: ``
            },
            {
              type: `p`,
              text: ``
            },
            {
              type: `li`,
              text: ``
            },
            {
              type: `li`,
              text: ``
            },
            {
              type: `li`,
              text: ``
            },
            {
              type: `li`,
              text: ``
            },
            {
              type: `p`,
              text: ``
            },
            {
              type: `li`,
              text: ``
            },
            {
              type: `li`,
              text: ``
            },
            {
              type: `li`,
              text: ``
            },
            {
              type: `li`,
              text: ``
            }
          ]
        },
        {
          id: `administration-guidelines`,
          title: `إرشادات الإدارة`,
          items: [
            {
              type: `p`,
              text: `بسم الله الرحمن الرحيم`
            },
            {
              type: `p`,
              text: `منظمة الخلد للاعمار والتنمية`
            },
            {
              type: `p`,
              text: ``
            },
            {
              type: `p`,
              text: ``
            },
            {
              type: `p`,
              text: ``
            },
            {
              type: `p`,
              text: ``
            },
            

            {
              type: `p`,
              text: ``
            },
            {
              type: `p`,
              text: ``
            },
            {
              type: `li`,
              text: ``
            },
            {
              type: `li`,
              text: ``
            },
            {
              type: `li`,
              text: ``
            },
            {
              type: `p`,
              text: ``
            },
            {
              type: `li`,
              text: ``
            },
            {
              type: `li`,
              text: ``
            },
            {
              type: `li`,
              text: ``
            },
            {
              type: `li`,
              text: ``
            },
            {
              type: `li`,
              text: ``
            },
            {
              type: `p`,
              text: ``
            },
            {
              type: `li`,
              text: ``
            },
            {
              type: `li`,
              text: ``
            },
            {
              type: `p`,
              text: ``
            },
            {
              type: `li`,
              text: ``
            },
            {
              type: `p`,
              text: ``
            },
            {
              type: `li`,
              text: ``
            },
            {
              type: `p`,
              text: ``
            },
            {
              type: `p`,
              text: ``
            },
            {
              type: `p`,
              text: ``
            },
            {
              type: `p`,
              text: ``
            },
            {
              type: `p`,
              text: ``
            },
            {
              type: `p`,
              text: ``
            }
          ]
        },
        {
          id: `our-organisatiob-adminstrarion-guidelines`,
          title: ``,
          items: [
            {
              type: `p`,
              text: ``
            },
            {
              type: `p`,
              text: ``
            },
            {
              type: `p`,
              text: ``
            },
            {
              type: `p`,
              text: ``
            },

            {
              type: `p`,
              text: ``
            },
            {
              type: `p`,
              text: ``
            },
            {
              type: `p`,
              text: ``
            },
            {
              type: `p`,
              text: ``
            },
            {
              type: `p`,
              text: ``
            },
            {
              type: `p`,
              text: ``
            },
            {
              type: `p`,
              text: ``
            },
            {
              type: `p`,
              text: ``
            },
            {
              type: `p`,
              text: ``
            },
            {
              type: `p`,
              text: ``
            },
            {
              type: `p`,
              text: ``
            },
            {
              type: `p`,
              text: ``
            },
            {
              type: `p`,
              text: ``
            },
            {
              type: `p`,
              text: ``
            },
            {
              type: `p`,
              text: ``
            },
            {
              type: `p`,
              text: ``
            },
            {
              type: `p`,
              text: ``
            },
            {
              type: `p`,
              text: ``
            },
            {
              type: `p`,
              text: ``
            },
            {
              type: `p`,
              text: ``
            },
            {
              type: `p`,
              text: ``
            },
            {
              type: `p`,
              text: ``
            },
            {
              type: `p`,
              text: ``
            },
            {
              type: `p`,
              text: ``
            },
            {
              type: `p`,
              text: ``
            },
            {
              type: `p`,
              text: `[7:12 م، 2025/12/16] Suhair Salah: مشروع مراكز اجتماعية للدعم النفسي لنازحي الحرب`
            },
            {
              type: `p`,
              text: `[7:12 م، 2025/12/16] Suhair Salah: مشروع مراكز اجتماعية للدعم النفسي لنازحي الحرب بمعسكر الدبة`
            },
            {
              type: `p`,
              text: `مشروع مراكز اجتماعية للدعم النفسي لنازحي الحرب بمعسكر الدبة`
            },
            {
              type: `p`,
              text: `المقدمة:`
            },
            {
              type: `p`,
              text: `يهدف هذا المشروع إلى تقديم الدعم النفسي والاجتماعي للنازحين بسبب الحرب في معسكر الدبة، حيث يواجهون تحديات نفسية واجتماعية كبيرة نتيجة للتهجير القسري والفقدان والاضطرابات النفسية.`
            },
            {
              type: `p`,
              text: `الأهداف:`
            },
            {
              type: `p`,
              text: `1. توفير الدعم النفسي: تقديم الدعم النفسي للنازحين لتحسين صحتهم النفسية ومساعدتهم على التعامل مع الصدمات النفسية.`
            },
            {
              type: `p`,
              text: `2. تعزيز التماسك الاجتماعي: تعزيز التماسك الاجتماعي بين النازحين وتحسين قدرتهم على التعامل مع التحديات اليومية.`
            },
            {
              type: `p`,
              text: `3. توفير الخدمات الاجتماعية: توفير الخدمات الاجتماعية الأساسية مثل التعليم والتدريب المهني والرعاية الصحية.`
            },
            {
              type: `p`,
              text: `الأنشطة:`
            },
            {
              type: `p`,
              text: `1. تقديم الدعم النفسي الفردي: تقديم الدعم النفسي الفردي للنازحين من قبل أخصائيين نفسيين مدربين.`
            },
            {
              type: `p`,
              text: `2. الجلسات الجماعية: تنظيم جلسات جماعية للنازحين لتعزيز التماسك الاجتماعي وتحسين مهارات التعامل مع التحديات.`
            },
            {
              type: `p`,
              text: `3. الأنشطة الترفيهية: تنظيم الأنشطة الترفيهية مثل الألعاب والفنون لتعزيز الصحة النفسية.`
            },
            {
              type: `p`,
              text: `4. التدريب المهني: توفير التدريب المهني للنازحين لتحسين فرصهم في الحصول على عمل.`
            },
            {
              type: `p`,
              text: `5. الرعاية الصحية: توفير الرعاية الصحية الأساسية للنازحين.`
            },
            {
              type: `p`,
              text: `الخطة التنفيذية:`
            },
            {
              type: `p`,
              text: `1. التخطيط والتصميم: التخطيط والتصميم للمشروع مع الفريق المعني.`
            },
            {
              type: `p`,
              text: `2. التواصل مع المجتمع: التواصل مع المجتمع المحلي والنازحين لشرح المشروع وتلقي الملاحظات.`
            },
            {
              type: `p`,
              text: `3. تنفيذ الأنشطة: تنفيذ الأنشطة المذكورة أعلاه.`
            },
            {
              type: `p`,
              text: `4. المتابعة والتقييم: متابعة وتقييم المشروع لضمان تحقيق الأهداف.`
            },
            {
              type: `p`,
              text: `التمويل:`
            },
            {
              type: `p`,
              text: `سيتم تمويل المشروع من خلال المنظمات الدولية والمنظمات غير الحكومية والجهات المانحة الأخرى.`
            },
            {
              type: `p`,
              text: `المدد الزمنية:`
            },
            {
              type: `p`,
              text: `سيتم تنفيذ المشروع على مدى 12 شهرًا.`
            },
            {
              type: `p`,
              text: `النتائج المتوقعة:`
            },
            {
              type: `p`,
              text: `1. تحسين الصحة النفسية: تحسين الصحة النفسية للنازحين.`
            },
            {
              type: `p`,
              text: `2. تعزيز التماسك الاجتماعي: تعزيز التماسك الاجتماعي بين النازحين.`
            },
            {
              type: `p`,
              text: `3. توفير الخدمات الاجتماعية: توفير الخدمات الاجتماعية الأساسية للنازحين.`
            },
            {
              type: `p`,
              text: `الخاتمة:`
            },
            {
              type: `p`,
              text: `يهدف هذا المشروع إلى تقديم الدعم النفسي والاجتماعي للنازحين بسبب الحرب في معسكر الدبة. نأمل أن يساهم هذا المشروع في تحسين حياة النازحين وتعزيز صحتهم النفسية والاجتماعية.`
            },
            {
              type: `p`,
              text: `مرحبًا!`
            },
            {
              type: `p`,
              text: `مشروع مراكز اجتماعية للدعم النفسي لنازحي الحرب هو مشروع هام يهدف إلى تقديم الدعم النفسي والاجتماعي للنازحين بسبب الحرب. إليك بعض الأفكار لتطوير هذا المشروع:`
            },
            {
              type: `p`,
              text: `الأهداف:`
            },
            {
              type: `p`,
              text: `1. توفير الدعم النفسي: تقديم الدعم النفسي للنازحين لتحسين صحتهم النفسية ومساعدتهم على التعامل مع الصدمات النفسية.`
            },
            {
              type: `p`,
              text: `2. تعزيز التماسك الاجتماعي: تعزيز التماسك الاجتماعي بين النازحين وتحسين قدرتهم على التعامل مع التحديات اليومية.`
            },
            {
              type: `p`,
              text: `3. توفير الخدمات الاجتماعية: توفير الخدمات الاجتماعية الأساسية مثل التعليم والتدريب المهني والرعاية الصحية.`
            },
            {
              type: `p`,
              text: `الأنشطة:`
            },
            {
              type: `p`,
              text: `1. تقديم الدعم النفسي الفردي: تقديم الدعم النفسي الفردي للنازحين من قبل أخصائيين نفسيين مدربين.`
            },
            {
              type: `p`,
              text: `2. الجلسات الجماعية: تنظيم جلسات جماعية للنازحين لتعزيز التماسك الاجتماعي وتحسين مهارات التعامل مع التحديات.`
            },
            {
              type: `p`,
              text: `3. الأنشطة الترفيهية: تنظيم الأنشطة الترفيهية مثل الألعاب والفنون لتعزيز الصحة النفسية.`
            },
            {
              type: `p`,
              text: `4. التدريب المهني: توفير التدريب المهني للنازحين لتحسين فرصهم في الحصول على عمل.`
            },
            {
              type: `p`,
              text: `5. الرعاية الصحية: توفير الرعاية الصحية الأساسية للنازحين.`
            },
            {
              type: `p`,
              text: `الخطة التنفيذية:`
            },
            {
              type: `p`,
              text: `1. التخطيط والتصميم: التخطيط والتصميم للمشروع مع الفريق المعني.`
            },
            {
              type: `p`,
              text: `2. التواصل مع المجتمع: التواصل مع المجتمع المحلي والنازحين لشرح المشروع وتلقي الملاحظات.`
            },
            {
              type: `p`,
              text: `3. تنفيذ الأنشطة: تنفيذ الأنشطة المذكورة أعلاه.`
            },
            {
              type: `p`,
              text: `4. المتابعة والتقييم: متابعة وتقييم المشروع لضمان تحقيق الأهداف.`
            },
            {
              type: `p`,
              text: `التمويل:`
            },
            {
              type: `p`,
              text: `سيتم تمويل المشروع من خلال المنظمات الدولية والمنظمات غير الحكومية والجهات المانحة الأخرى.`
            },
            {
              type: `p`,
              text: `المدد الزمنية:`
            },
            {
              type: `p`,
              text: `سيتم تنفيذ المشروع على مدى 12 شهرًا.`
            },
            {
              type: `p`,
              text: `النتائج المتوقعة:`
            },
            {
              type: `p`,
              text: `1. تحسين الصحة النفسية: تحسين الصحة النفسية للنازحين.`
            },
            {
              type: `p`,
              text: `2. تعزيز التماسك الاجتماعي: تعزيز التماسك الاجتماعي بين النازحين.`
            },
            {
              type: `p`,
              text: `3. توفير الخدمات الاجتماعية: توفير الخدمات الاجتماعية الأساسية للنازحين.`
            },
            {
              type: `p`,
              text: `هل هناك شيء آخر يمكنني مساعدتك به؟`
            }
          ]
        },
        {
          id: `roles-and-responsibilities`,
          title: `الأدوار والمسؤوليات`,
          items: [
            {
              type: `p`,
              text: `بسم الله الرحمن الرحيم`
            },
            {
              type: `p`,
              text: `منظمة الخلد للاعمار والتنمية`
            },
            {
              type: `p`,
              text: ``
            },
            {
              type: `p`,
              text: ``
            },
            {
              type: `li`,
              text: ``
            },
            {
              type: `li`,
              text: ``
            },
            {
              type: `li`,
              text: ``
            },
            {
              type: `li`,
              text: ``
            },
            {
              type: `p`,
              text: ``
            },
            {
              type: `p`,
              text: ``
            }
          ]
        },
        {
          id: `segregation-of-duties-and-deligation`,
          title: `فصل المهام والتفويض`,
          items: [
            {
              type: `p`,
              text: `بسم الله الرحمن الرحيم`
            },
            {
              type: `p`,
              text: `منظمة الخلد للاعمار والتنمية`
            },
            {
              type: `p`,
              text: ``
            },
            {
              type: `p`,
              text: ``
            },
            {
              type: `p`,
              text: ``
            },
            {
              type: `p`,
              text: ``
            },

            {
              type: `p`,
              text: ``
            },
            {
              type: `p`,
              text: ``
            },
            {
              type: `p`,
              text: ``
            },
            {
              type: `p`,
              text: ``
            },
            {
              type: `p`,
              text: ``
            },
            {
              type: `p`,
              text: ``
            },
            {
              type: `p`,
              text: ``
            },
            {
              type: `p`,
              text: ``
            },
            {
              type: `p`,
              text: ``
            },
            {
              type: `p`,
              text: ``
            },
            {
              type: `p`,
              text: ``
            },
            {
              type: `p`,
              text: ``
            },
            {
              type: `p`,
              text: ``
            },
            {
              type: `p`,
              text: ``
            },
            {
              type: `p`,
              text: ``
            },
            {
              type: `p`,
              text: ``
            },
            {
              type: `p`,
              text: ``
            },
            {
              type: `p`,
              text: ``
            },
            {
              type: `p`,
              text: ``
            },
            {
              type: `p`,
              text: ``
            },
            {
              type: `p`,
              text: ``
            },
            {
              type: `p`,
              text: ``
            },
            {
              type: `p`,
              text: ``
            },
            {
              type: `p`,
              text: ``
            },
            {
              type: `p`,
              text: ``
            },
            {
              type: `p`,
              text: ``
            },
            {
              type: `p`,
              text: ``
            },
            {
              type: `p`,
              text: ``
            },
            {
              type: `p`,
              text: ``
            },
            {
              type: `p`,
              text: ``
            },
            {
              type: `p`,
              text: ``
            },
            {
              type: `p`,
              text: ``
            },
            {
              type: `p`,
              text: ``
            },
            {
              type: `p`,
              text: ``
            },
            {
              type: `p`,
              text: ``
            },
            {
              type: `p`,
              text: ``
            },
            {
              type: `p`,
              text: ``
            },
            {
              type: `p`,
              text: ``
            }
          ]
        },
        {
          id: `internal-audit-functions`,
          title: `وظائف التدقيق الداخلي`,
          items: [
            {
              type: `p`,
              text: `بسم الله الرحمن الرحيم`
            },
            {
              type: `p`,
              text: `منظمة الخلد للاعمار والتنمية`
            },
            {
              type: `p`,
              text: ``
            },
            {
              type: `p`,
              text: ``
            },
            {
              type: `p`,
              text: ``
            },
            {
              type: `p`,
              text: ``
            },

            {
              type: `p`,
              text: ``
            },
            {
              type: `li`,
              text: ``
            },
            {
              type: `li`,
              text: ``
            },
            {
              type: `li`,
              text: ``
            },
            {
              type: `li`,
              text: ``
            },
            {
              type: `p`,
              text: ``
            },
            {
              type: `li`,
              text: ``
            },
            {
              type: `li`,
              text: ``
            },
            {
              type: `li`,
              text: ``
            },
            {
              type: `li`,
              text: ``
            },
            {
              type: `li`,
              text: ``
            },
            {
              type: `p`,
              text: ``
            },
            {
              type: `li`,
              text: ``
            },
            {
              type: `li`,
              text: ``
            },
            {
              type: `li`,
              text: ``
            },
            {
              type: `li`,
              text: ``
            },
            {
              type: `p`,
              text: ``
            },
            {
              type: `li`,
              text: ``
            },
            {
              type: `li`,
              text: ``
            },
            {
              type: `li`,
              text: ``
            },
            {
              type: `p`,
              text: ``
            },
            {
              type: `p`,
              text: ``
            },
            {
              type: `li`,
              text: ``
            },
            {
              type: `li`,
              text: ``
            },
            {
              type: `li`,
              text: ``
            },
            {
              type: `li`,
              text: ``
            },
            {
              type: `p`,
              text: ``
            },
            {
              type: `p`,
              text: ``
            }
          ]
        },
        {
          id: `risk-management-doc`,
          title: `إدارة المخاطر`,
          items: [
            {
              type: `p`,
              text: `بسم الله الرحمن الرحيم`
            },
            {
              type: `p`,
              text: `منظمة الخلد للاعمار والتنمية`
            },
            {
              type: `p`,
              text: ``
            },
            {
              type: `p`,
              text: ``
            },
            {
              type: `p`,
              text: ``
            },
            {
              type: `p`,
              text: ``
            },
            {
              type: `p`,
              text: ``
            },
            {
              type: `p`,
              text: ``
            },
            {
              type: `p`,
              text: ``
            },
            {
              type: `p`,
              text: ``
            },
            {
              type: `p`,
              text: ``
            },
            {
              type: `p`,
              text: ``
            },
            {
              type: `p`,
              text: ``
            },
            {
              type: `p`,
              text: ``
            },
            {
              type: `p`,
              text: ``
            },
            {
              type: `p`,
              text: ``
            },
            {
              type: `p`,
              text: ``
            },
            {
              type: `p`,
              text: ``
            },
            {
              type: `p`,
              text: ``
            },
            {
              type: `p`,
              text: ``
            },
            {
              type: `p`,
              text: ``
            },
            {
              type: `p`,
              text: ``
            },
            {
              type: `p`,
              text: ``
            },
            {
              type: `p`,
              text: ``
            },
            {
              type: `p`,
              text: ``
            },
            {
              type: `p`,
              text: ``
            },
            {
              type: `p`,
              text: ``
            },
            {
              type: `p`,
              text: ``
            },
            {
              type: `p`,
              text: ``
            },
            {
              type: `p`,
              text: ``
            },
            {
              type: `p`,
              text: ``
            },
            {
              type: `p`,
              text: ``
            },
            {
              type: `p`,
              text: ``
            },
            {
              type: `p`,
              text: ``
            },
            {
              type: `p`,
              text: ``
            },
            {
              type: `p`,
              text: ``
            },
            {
              type: `p`,
              text: ``
            },
            {
              type: `p`,
              text: ``
            },
            {
              type: `p`,
              text: ``
            },
            {
              type: `p`,
              text: ``
            },
            {
              type: `p`,
              text: ``
            },
            {
              type: `p`,
              text: ``
            },
            {
              type: `p`,
              text: ``
            },
            {
              type: `p`,
              text: ``
            },
            {
              type: `p`,
              text: ``
            },
            {
              type: `p`,
              text: ``
            },
            {
              type: `p`,
              text: ``
            },
            {
              type: `p`,
              text: ``
            },
            {
              type: `p`,
              text: ``
            },
            {
              type: `p`,
              text: ``
            },
            {
              type: `p`,
              text: ``
            },
            {
              type: `p`,
              text: ``
            },
            {
              type: `p`,
              text: ``
            },
            {
              type: `p`,
              text: ``
            },
            {
              type: `p`,
              text: ``
            },
            {
              type: `p`,
              text: ``
            },
            {
              type: `p`,
              text: ``
            },
            {
              type: `p`,
              text: ``
            },
            {
              type: `p`,
              text: ``
            },
            {
              type: `p`,
              text: ``
            },
            {
              type: `p`,
              text: ``
            },
            {
              type: `p`,
              text: ``
            },
            {
              type: `p`,
              text: ``
            }
          ]
        },
        {
          id: `transparency-policy`,
          title: `سياسة الشفافية`,
          items: [
            {
              type: `p`,
              text: `بسم الله الرحمن الرحيم`
            },
            {
              type: `p`,
              text: `منظمة الخلد للاعمار والتنمية`
            },
            {
              type: `p`,
              text: ``
            },
            {
              type: `p`,
              text: ``
            },
            {
              type: `p`,
              text: ``
            },
            {
              type: `p`,
              text: ``
            },

            {
              type: `p`,
              text: ``
            },
            {
              type: `p`,
              text: ``
            },
            {
              type: `li`,
              text: ``
            },
            {
              type: `li`,
              text: ``
            },
            {
              type: `li`,
              text: ``
            },
            {
              type: `li`,
              text: ``
            },
            {
              type: `p`,
              text: ``
            },
            {
              type: `li`,
              text: ``
            },
            {
              type: `li`,
              text: ``
            },
            {
              type: `li`,
              text: ``
            },
            {
              type: `li`,
              text: ``
            },
            {
              type: `li`,
              text: ``
            },
            {
              type: `p`,
              text: ``
            },
            {
              type: `li`,
              text: ``
            },
            {
              type: `li`,
              text: ``
            },
            {
              type: `li`,
              text: ``
            },
            {
              type: `p`,
              text: ``
            },
            {
              type: `li`,
              text: ``
            },
            {
              type: `li`,
              text: ``
            },
            {
              type: `li`,
              text: ``
            },
            {
              type: `li`,
              text: ``
            },
            {
              type: `p`,
              text: ``
            },
            {
              type: `p`,
              text: ``
            },
            {
              type: `p`,
              text: ``
            },
            {
              type: `p`,
              text: ``
            }
          ]
        },
        {
          id: `framework-for-accountability-to-affected-populations-introduction`,
          title: `مقدمة إطار المساءلة تجاه المتأثرين`,
          items: [
            {
              type: `p`,
              text: `بسم الله الرحمن الرحيم`
            },
            {
              type: `p`,
              text: `منظمة الخلد للاعمار والتنمية`
            },
            {
              type: `p`,
              text: ``
            },
            {
              type: `p`,
              text: ``
            },
            {
              type: `p`,
              text: ``
            },
            {
              type: `p`,
              text: ``
            },
            {
              type: `li`,
              text: ``
            },
            {
              type: `li`,
              text: ``
            },
            {
              type: `li`,
              text: ``
            },
            {
              type: `li`,
              text: ``
            },
            {
              type: `p`,
              text: ``
            },
            {
              type: `li`,
              text: ``
            },
            {
              type: `li`,
              text: ``
            },
            {
              type: `li`,
              text: ``
            },
            {
              type: `li`,
              text: ``
            },
            {
              type: `p`,
              text: ``
            },
            {
              type: `li`,
              text: ``
            },
            {
              type: `li`,
              text: ``
            },
            {
              type: `li`,
              text: ``
            },
            {
              type: `li`,
              text: ``
            },
            {
              type: `p`,
              text: ``
            },
            {
              type: `li`,
              text: ``
            },
            {
              type: `li`,
              text: ``
            },
            {
              type: `li`,
              text: ``
            },
            {
              type: `p`,
              text: ``
            }
          ]
        }
      ]
    },
    {
      title: `الموارد البشرية والحماية`,
      slug: `human-resources-safeguarding`,
      docs: [
        {
          id: `personnel-guideline`,
          title: `دليل شؤون العاملين`,
          items: [
            {
              type: `p`,
              text: `بسم الله الرحمن الرحيم`
            },
            {
              type: `p`,
              text: `منظمة الخلد للاعمار والتنمية`
            },
            {
              type: `p`,
              text: ``
            },
            {
              type: `p`,
              text: ``
            },
            {
              type: `p`,
              text: ``
            },
            {
              type: `p`,
              text: ``
            },
            {
              type: `li`,
              text: ``
            },
            {
              type: `li`,
              text: ``
            },
            {
              type: `li`,
              text: ``
            },
            {
              type: `li`,
              text: ``
            },
            {
              type: `li`,
              text: ``
            },
            {
              type: `li`,
              text: ``
            },
            {
              type: `li`,
              text: ``
            },
            {
              type: `li`,
              text: ``
            }
          ]
        },
        {
          id: `personal-guideline`,
          title: `إرشادات السلوك الشخصي`,
          items: [
            {
              type: `p`,
              text: `بسم الله الرحمن الرحيم`
            },
            {
              type: `p`,
              text: `منظمة الخلد للاعمار والتنمية`
            },
            {
              type: `p`,
              text: ``
            },
            {
              type: `p`,
              text: ``
            },
            {
              type: `p`,
              text: ``
            },
            {
              type: `p`,
              text: ``
            },
            {
              type: `p`,
              text: ``
            },
            {
              type: `p`,
              text: ``
            },
            {
              type: `p`,
              text: ``
            },
            {
              type: `p`,
              text: ``
            },
            {
              type: `p`,
              text: ``
            },
            {
              type: `p`,
              text: ``
            },
            {
              type: `p`,
              text: ``
            },
            {
              type: `p`,
              text: ``
            },
            {
              type: `p`,
              text: ``
            }
          ]
        },
        {
          id: `policies-and-procedures-to-prevent-sexual-exploitation-and-abuse-introduction`,
          title: `مقدمة سياسات وإجراءات منع الاستغلال والانتهاك الجنسي`,
          items: [
            {
              type: `p`,
              text: `بسم الله الرحمن الرحيم`
            },
            {
              type: `p`,
              text: `منظمة الخلد للاعمار والتنمية`
            },
            {
              type: `p`,
              text: ``
            },
            {
              type: `p`,
              text: ``
            },
            {
              type: `p`,
              text: ``
            },
            {
              type: `p`,
              text: ``
            },
            {
              type: `p`,
              text: ``
            },
            {
              type: `p`,
              text: `التعاريف:`
            },
            {
              type: `li`,
              text: ``
            },
            {
              type: `li`,
              text: ``
            },
            {
              type: `p`,
              text: ``
            },
            {
              type: `li`,
              text: ``
            },
            {
              type: `li`,
              text: ``
            },
            {
              type: `li`,
              text: ``
            },
            {
              type: `li`,
              text: ``
            },
            {
              type: `p`,
              text: `الإجراءات:`
            },
            {
              type: `li`,
              text: ``
            },
            {
              type: `li`,
              text: ``
            },
            {
              type: `li`,
              text: ``
            },
            {
              type: `li`,
              text: ``
            },
            {
              type: `p`,
              text: ``
            },
            {
              type: `li`,
              text: ``
            },
            {
              type: `li`,
              text: ``
            },
            {
              type: `li`,
              text: ``
            },
            {
              type: `p`,
              text: ``
            }
          ]
        },
        {
          id: `policies-and-procedures-to-prevent-sexual-exploitation-and-abuse`,
          title: `سياسات وإجراءات منع الاستغلال والانتهاك الجنسي`,
          items: [
            {
              type: `p`,
              text: ``
            },
            {
              type: `p`,
              text: ``
            },
            {
              type: `p`,
              text: ``
            },
            {
              type: `p`,
              text: ``
            },
            {
              type: `p`,
              text: ``
            },
 
            {
              type: `p`,
              text: ``
            },
            {
              type: `p`,
              text: `التعاريف:`
            },
            {
              type: `p`,
              text: ``
            },
            {
              type: `p`,
              text: ``
            },
            {
              type: `p`,
              text: ``
            },
            {
              type: `p`,
              text: ``
            },
            {
              type: `p`,
              text: ``
            },
            {
              type: `p`,
              text: ``
            },
            {
              type: `p`,
              text: ``
            },
            {
              type: `p`,
              text: `الإجراءات:`
            },
            {
              type: `p`,
              text: ``
            },
            {
              type: `p`,
              text: ``
            },
            {
              type: `p`,
              text: ``
            },
            {
              type: `p`,
              text: ``
            },
            {
              type: `p`,
              text: ``
            },
            {
              type: `p`,
              text: ``
            },
            {
              type: `p`,
              text: ``
            },
            {
              type: `p`,
              text: ``
            },
            {
              type: `p`,
              text: ``
            },
            {
              type: `p`,
              text: ``
            },
            {
              type: `p`,
              text: ``
            },
            {
              type: `p`,
              text: ``
            }
          ]
        },
        {
          id: `polices-and-procedures-prevent-sea`,
          title: `سياسات وإجراءات منع SEA`,
          items: [
            {
              type: `p`,
              text: `بسم الله الرحمن الرحيم`
            },
            {
              type: `p`,
              text: `منظمة الخلد للاعمار والتنمية`
            },
            {
              type: `p`,
              text: ``
            },
            {
              type: `p`,
              text: ``
            },
            {
              type: `p`,
              text: ``
            },
            {
              type: `p`,
              text: ``
            },
            {
              type: `p`,
              text: ``
            },
            {
              type: `p`,
              text: ``
            },

            {
              type: `p`,
              text: ``
            },
            {
              type: `p`,
              text: `التعاريف:`
            },
            {
              type: `p`,
              text: ``
            },
            {
              type: `p`,
              text: ``
            },
            {
              type: `p`,
              text: ``
            },
            {
              type: `p`,
              text: ``
            },
            {
              type: `p`,
              text: ``
            },
            {
              type: `p`,
              text: ``
            },
            {
              type: `p`,
              text: ``
            },
            {
              type: `p`,
              text: `الإجراءات:`
            },
            {
              type: `p`,
              text: ``
            },
            {
              type: `p`,
              text: ``
            },
            {
              type: `p`,
              text: ``
            },
            {
              type: `p`,
              text: ``
            },
            {
              type: `p`,
              text: ``
            },
            {
              type: `p`,
              text: ``
            },
            {
              type: `p`,
              text: ``
            },
            {
              type: `p`,
              text: ``
            },
            {
              type: `p`,
              text: ``
            },
            {
              type: `p`,
              text: ``
            },
            {
              type: `p`,
              text: ``
            },
            {
              type: `p`,
              text: ``
            }
          ]
        }
      ]
    },
    {
      title: `الأمن والسلامة`,
      slug: `security-safety`,
      docs: [
        {
          id: `driving-security-and-safety-policy`,
          title: `سياسة أمن وسلامة القيادة`,
          items: [
            {
              type: `p`,
              text: `بسم الله الرحمن الرحيم`
            },
            {
              type: `p`,
              text: `منظمة الخلد للاعمار والتنمية`
            },
            {
              type: `p`,
              text: ``
            },
            {
              type: `p`,
              text: ``
            },
            {
              type: `p`,
              text: ``
            },
            {
              type: `p`,
              text: ``
            },

            {
              type: `p`,
              text: ``
            },
            {
              type: `p`,
              text: ``
            },
            {
              type: `li`,
              text: ``
            },
            {
              type: `li`,
              text: ``
            },
            {
              type: `li`,
              text: ``
            },
            {
              type: `p`,
              text: `الإجراءات:`
            },
            {
              type: `li`,
              text: ``
            },
            {
              type: `li`,
              text: ``
            },
            {
              type: `li`,
              text: ``
            },
            {
              type: `li`,
              text: ``
            },
            {
              type: `li`,
              text: ``
            },
            {
              type: `p`,
              text: `المسؤوليات:`
            },
            {
              type: `li`,
              text: ``
            },
            {
              type: `li`,
              text: ``
            },
            {
              type: `li`,
              text: ``
            },
            {
              type: `p`,
              text: ``
            },
            {
              type: `p`,
              text: ``
            },
            {
              type: `p`,
              text: ``
            },
            {
              type: `p`,
              text: ``
            },
            {
              type: `p`,
              text: ``
            }
          ]
        },
        {
          id: `security-procedures`,
          title: `إجراءات الأمن`,
          items: [
            {
              type: `p`,
              text: `بسم الله الرحمن الرحيم`
            },
            {
              type: `p`,
              text: `منظمة الخلد للاعمار والتنمية`
            },
            {
              type: `p`,
              text: ``
            },
            {
              type: `p`,
              text: ``
            },
            {
              type: `p`,
              text: ``
            },
            {
              type: `p`,
              text: ``
            },
 
            {
              type: `p`,
              text: ``
            },
            {
              type: `p`,
              text: ``
            },
            {
              type: `li`,
              text: ``
            },
            {
              type: `li`,
              text: ``
            },
            {
              type: `li`,
              text: ``
            },
            {
              type: `li`,
              text: ``
            },
            {
              type: `p`,
              text: ``
            },
            {
              type: `li`,
              text: ``
            },
            {
              type: `li`,
              text: ``
            },
            {
              type: `li`,
              text: ``
            },
            {
              type: `li`,
              text: ``
            },
            {
              type: `li`,
              text: ``
            },
            {
              type: `p`,
              text: ``
            },
            {
              type: `li`,
              text: ``
            },
            {
              type: `li`,
              text: ``
            },
            {
              type: `li`,
              text: ``
            },
            {
              type: `p`,
              text: ``
            },
            {
              type: `p`,
              text: ``
            },
            {
              type: `p`,
              text: ``
            },
            {
              type: `p`,
              text: ``
            }
          ]
        },
        {
          id: `personnel-security-procedure`,
          title: `إجراءات أمن العاملين`,
          items: [
            {
              type: `p`,
              text: `بسم الله الرحمن الرحيم`
            },
            {
              type: `p`,
              text: `منظمة الخلد للاعمار والتنمية`
            },
            {
              type: `p`,
              text: ``
            },
            {
              type: `p`,
              text: ``
            },
            {
              type: `p`,
              text: ``
            },
            {
              type: `p`,
              text: ``
            },
  
            {
              type: `p`,
              text: ``
            },
            {
              type: `p`,
              text: ``
            },
            {
              type: `li`,
              text: ``
            },
            {
              type: `li`,
              text: ``
            },
            {
              type: `li`,
              text: ``
            },
            {
              type: `li`,
              text: ``
            },
            {
              type: `li`,
              text: ``
            },
            {
              type: `li`,
              text: ``
            },
            {
              type: `li`,
              text: ``
            },
            {
              type: `p`,
              text: `الإجراءات:`
            },
            {
              type: `li`,
              text: ``
            },
            {
              type: `li`,
              text: ``
            },
            {
              type: `li`,
              text: ``
            },
            {
              type: `li`,
              text: ``
            },
            {
              type: `li`,
              text: ``
            },
            {
              type: `li`,
              text: ``
            },
            {
              type: `li`,
              text: ``
            },
            {
              type: `li`,
              text: ``
            },
            {
              type: `li`,
              text: ``
            },
            {
              type: `li`,
              text: ``
            },
            {
              type: `li`,
              text: ``
            },
            {
              type: `li`,
              text: ``
            },
            {
              type: `li`,
              text: ``
            },
            {
              type: `li`,
              text: ``
            },
            {
              type: `li`,
              text: ``
            },
            {
              type: `li`,
              text: ``
            },
            {
              type: `li`,
              text: ``
            },
            {
              type: `li`,
              text: ``
            },
            {
              type: `li`,
              text: ``
            },
            {
              type: `li`,
              text: ``
            },
            {
              type: `li`,
              text: ``
            },
            {
              type: `p`,
              text: ``
            },
            {
              type: `p`,
              text: ``
            },
            {
              type: `p`,
              text: ``
            }
          ]
        }
      ]
    },
    {
      title: ``,
      slug: `procurement-finance`,
      docs: [
        {
          id: `procurement-regulations`,
          title: `لوائح المشتريات`,
          items: [
            {
              type: `p`,
              text: `بسم الله الرحمن الرحيم`
            },
            {
              type: `p`,
              text: `منظمة الخلد للاعمار والتنمية`
            },
            {
              type: `p`,
              text: ``
            },
            {
              type: `p`,
              text: ``
            },
            {
              type: `p`,
              text: ``
            },
            {
              type: `p`,
              text: ``
            },
  
            {
              type: `p`,
              text: ``
            },
            {
              type: `p`,
              text: ``
            },
            {
              type: `li`,
              text: ``
            },
            {
              type: `li`,
              text: ``
            },
            {
              type: `li`,
              text: ``
            },
            {
              type: `li`,
              text: ``
            },
            {
              type: `p`,
              text: ``
            },
            {
              type: `li`,
              text: ``
            },
            {
              type: `li`,
              text: ``
            },
            {
              type: `li`,
              text: ``
            },
            {
              type: `li`,
              text: ``
            },
            {
              type: `p`,
              text: ``
            },
            {
              type: `li`,
              text: ``
            },
            {
              type: `li`,
              text: ``
            },
            {
              type: `li`,
              text: ``
            },
            {
              type: `p`,
              text: ``
            },
            {
              type: `li`,
              text: ``
            },
            {
              type: `li`,
              text: ``
            },
            {
              type: `li`,
              text: ``
            },
            {
              type: `p`,
              text: ``
            },
            {
              type: `li`,
              text: ``
            },
            {
              type: `li`,
              text: ``
            },
            {
              type: `li`,
              text: ``
            },
            {
              type: `li`,
              text: ``
            },
            {
              type: `p`,
              text: ``
            },
            {
              type: `li`,
              text: ``
            },
            {
              type: `li`,
              text: ``
            },
            {
              type: `li`,
              text: ``
            },
            {
              type: `p`,
              text: ``
            },
            {
              type: `li`,
              text: ``
            },
            {
              type: `li`,
              text: ``
            },
            {
              type: `p`,
              text: ``
            },
            {
              type: `p`,
              text: ``
            }
          ]
        }
      ]
    },
    {
      title: ``,
      slug: `logistics-fleet`,
      docs: [
        {
          id: `managing-stocks-and-warehouse-policies`,
          title: `سياسات إدارة المخزون والمستودعات`,
          items: [
            {
              type: `p`,
              text: `بسم الله الرحمن الرحيم`
            },
            {
              type: `p`,
              text: `منظمة الخلد للاعمار والتنمية`
            },
            {
              type: `p`,
              text: ``
            },
            {
              type: `p`,
              text: ``
            },
            {
              type: `p`,
              text: ``
            },
            {
              type: `p`,
              text: ``
            },
   
            {
              type: `p`,
              text: ``
            },
            {
              type: `p`,
              text: ``
            },
            {
              type: `li`,
              text: ``
            },
            {
              type: `li`,
              text: ``
            },
            {
              type: `li`,
              text: ``
            },
            {
              type: `li`,
              text: ``
            },
            {
              type: `p`,
              text: ``
            },
            {
              type: `li`,
              text: ``
            },
            {
              type: `li`,
              text: ``
            },
            {
              type: `li`,
              text: ``
            },
            {
              type: `li`,
              text: ``
            },
            {
              type: `p`,
              text: `الإجراءات:`
            },
            {
              type: `li`,
              text: ``
            },
            {
              type: `li`,
              text: ``
            },
            {
              type: `li`,
              text: ``
            },
            {
              type: `li`,
              text: ``
            },
            {
              type: `li`,
              text: ``
            },
            {
              type: `p`,
              text: `المسؤوليات:`
            },
            {
              type: `li`,
              text: ``
            },
            {
              type: `li`,
              text: ``
            },
            {
              type: `li`,
              text: ``
            },
            {
              type: `p`,
              text: ``
            },
            {
              type: `p`,
              text: ``
            }
          ]
        },
        {
          id: `vehicle-maintenance-program`,
          title: `برنامج صيانة المركبات`,
          items: [
            {
              type: `p`,
              text: `بسم الله الرحمن الرحيم`
            },
            {
              type: `p`,
              text: `منظمة الخلد للاعمار والتنمية`
            },
            {
              type: `p`,
              text: ``
            },
            {
              type: `p`,
              text: ``
            },
            {
              type: `p`,
              text: ``
            },
            {
              type: `p`,
              text: ``
            },
            {
              type: `p`,
              text: ``
            },
            {
              type: `li`,
              text: ``
            },
            {
              type: `li`,
              text: ``
            },
            {
              type: `li`,
              text: ``
            },
            {
              type: `li`,
              text: ``
            },
 
            {
              type: `p`,
              text: ``
            },
            {
              type: `p`,
              text: ``
            },
            {
              type: `li`,
              text: ``
            },
            {
              type: `li`,
              text: ``
            },
            {
              type: `li`,
              text: ``
            },
            {
              type: `li`,
              text: ``
            },
            {
              type: `li`,
              text: ``
            },
            {
              type: `p`,
              text: ``
            },
            {
              type: `li`,
              text: ``
            },
            {
              type: `li`,
              text: ``
            },
            {
              type: `li`,
              text: ``
            },
            {
              type: `li`,
              text: ``
            },
            {
              type: `li`,
              text: ``
            },
            {
              type: `p`,
              text: `المسؤوليات:`
            },
            {
              type: `li`,
              text: ``
            },
            {
              type: `li`,
              text: ``
            },
            {
              type: `li`,
              text: ``
            },
            {
              type: `p`,
              text: ``
            },
            {
              type: `li`,
              text: ``
            },
            {
              type: `li`,
              text: ``
            },
            {
              type: `p`,
              text: ``
            },
            {
              type: `p`,
              text: ``
            }
          ]
        }
      ]
    }
  ],
  en: [
    {
      title: `Governance & Administration`,
      slug: `governance-administration`,
      docs: [
        {
          id: `adequate-filing-system`,
          title: `Adequate Filing System`,
          items: [
            {
              type: `p`,
              text: `بسم الله الرحمن الرحيم`
            },
            {
              type: `p`,
              text: `منظمة الخلد للاعمار والتنمية`
            },
            {
              type: `p`,
              text: `AL-KHOLD ORGNIZATION FOR 
RECONSTRACTION and DEVELOPMENT`
            },
            {
              type: `p`,
              text: `Adequate Filing System`
            },
            {
              type: `p`,
              text: `An adequate filing system is essential for our organization to ensure that documents are properly stored, retrieved, and managed. Here are some guidelines for establishing an adequate filing system:`
            },
            {
              type: `p`,
              text: `Filing System Components:`
            },
            {
              type: `li`,
              text: `Centralized Filing System: A centralized filing system should be established to ensure that all documents are stored in one location.`
            },
            {
              type: `li`,
              text: `Categorization: Documents should be categorized and filed according to a logical and consistent system.`
            },
            {
              type: `li`,
              text: `Indexing: Documents should be indexed to facilitate easy retrieval.`
            },
            {
              type: `li`,
              text: `Labeling: Files and folders should be clearly labeled to identify their contents.`
            },
            {
              type: `li`,
              text: `Security: The filing system should be secure to prevent unauthorized access.`
            },
            {
              type: `p`,
              text: `Filing System Procedures`
            },
            {
              type: `li`,
              text: `Document Receipt: All documents should be received and processed in a timely manner.`
            },
            {
              type: `li`,
              text: `Document Review: Documents should be reviewed for accuracy and completeness before filing`
            },
            {
              type: `li`,
              text: `Filing: Documents should be filed in the designated location.`
            },
            {
              type: `li`,
              text: `Retrieval: Documents should be retrieved in a timely manner when needed.`
            },
            {
              type: `li`,
              text: `Retention: Documents should be retained for the required period of time.`
            },
            {
              type: `p`,
              text: `Filing System Types:`
            },
            {
              type: `li`,
              text: `Physical Filing System: A physical filing system uses paper files and folders to store documents.`
            },
            {
              type: `li`,
              text: `Electronic Filing System: An electronic filing system uses digital storage devices to store documents.`
            },
            {
              type: `li`,
              text: `Hybrid Filing System: A hybrid filing system combines physical and electronic filing systems.`
            },
            {
              type: `p`,
              text: `Benefits of an Adequate Filing System:`
            },
            {
              type: `li`,
              text: `Improved Efficiency: An adequate filing system improves efficiency by reducing the time spent searching for documents.`
            },
            {
              type: `li`,
              text: `Increased Productivity: An adequate filing system increases productivity by allowing staff to focus on more important tasks.`
            },
            {
              type: `li`,
              text: `Better Compliance: An adequate filing system ensures compliance with regulatory requirements.`
            },
            {
              type: `li`,
              text: `Reduced Costs: An adequate filing system reduces costs associated with document storage and retrieval.`
            },
            {
              type: `p`,
              text: `Best Practices:`
            },
            {
              type: `li`,
              text: `Regularly Review and Update: Regularly review and update the filing system to ensure it remains effective`
            },
            {
              type: `li`,
              text: `Train Staff: Train staff on the filing system and procedures.`
            },
            {
              type: `li`,
              text: `Monitor and Evaluate: Monitor and evaluate the filing system to identify areas for improvement.`
            },
            {
              type: `li`,
              text: `Secure Documents: Ensure that documents are secure and protected from unauthorized access.`
            }
          ]
        },
        {
          id: `administration-guidelines`,
          title: `Administration Guidelines`,
          items: [
            {
              type: `p`,
              text: `بسم الله الرحمن الرحيم`
            },
            {
              type: `p`,
              text: `منظمة الخلد للاعمار والتنمية`
            },
            {
              type: `p`,
              text: `AL-KHOLD ORGNIZATION FOR 
RECONSTRACTION and DEVELOPMENT`
            },
            {
              type: `p`,
              text: `Administration Guidelines for Al-khold organization for reconstruction and development`
            },
            {
              type: `p`,
              text: `Introduction:`
            },
            {
              type: `p`,
              text: `These administration guidelines are designed to provide a framework for the effective and efficient management of [Organization Name]. They outline the roles and responsibilities of administrative staff, as well as the procedures for handling various administrative tasks.`
            },
            {
              type: `p`,
              text: `Scope:`
            },
            {
              type: `p`,
              text: `These guidelines apply to all administrative staff, including secretaries, administrative assistants, and other support staff.`
            },
            {
              type: `p`,
              text: `Roles and Responsibilities:`
            },
            {
              type: `li`,
              text: `Administrative Manager: The Administrative Manager is responsible for overseeing the administrative functions of the organization`
            },
            {
              type: `li`,
              text: `. Secretaries: Secretaries are responsible for providing administrative support to their designated departments or teams.`
            },
            {
              type: `li`,
              text: `. Administrative Assistants: Administrative Assistants provide general administrative support to the organization.`
            },
            {
              type: `p`,
              text: `Administrative Procedures:`
            },
            {
              type: `li`,
              text: `Correspondence: All correspondence, including letters and emails, will be handled in a professional and timely manner.`
            },
            {
              type: `li`,
              text: `Filing: All documents will be filed in a designated location and maintained in accordance with the organization's records management policy.`
            },
            {
              type: `li`,
              text: `Meetings: Meetings will be scheduled and organized in accordance with the organization's meeting procedures.`
            },
            {
              type: `li`,
              text: `Travel Arrangements: Travel arrangements will be made in accordance with the organization's travel policy.`
            },
            {
              type: `li`,
              text: `Expenses: Expenses will be reimbursed in accordance with the organization's expense reimbursement policy.`
            },
            {
              type: `p`,
              text: `Communication:`
            },
            {
              type: `li`,
              text: `Internal Communication: Internal communication will be conducted in a clear and respectful manner.`
            },
            {
              type: `li`,
              text: `External Communication: External communication will be conducted in a professional and respectful manner.`
            },
            {
              type: `p`,
              text: `Confidentiality:`
            },
            {
              type: `li`,
              text: `All administrative staff will maintain the confidentiality of sensitive information and documents.`
            },
            {
              type: `p`,
              text: `Record Keeping:`
            },
            {
              type: `li`,
              text: `All administrative records will be maintained in accordance with the organization's records management policy.`
            },
            {
              type: `p`,
              text: `Review and Update:`
            },
            {
              type: `p`,
              text: `These guidelines will be reviewed and updated annually or as needed to ensure they remain effective and relevant.`
            },
            {
              type: `p`,
              text: `Acknowledgement:`
            },
            {
              type: `p`,
              text: `All administrative staff will be required to acknowledge receipt and understanding of these guidelines.`
            },
            {
              type: `p`,
              text: `Effective Date:`
            },
            {
              type: `p`,
              text: `These guidelines are effective as of 1.1. 2025 and supersede all previous guideline`
            }
          ]
        },
        {
          id: `our-organisatiob-adminstrarion-guidelines`,
          title: `Our organisatiob adminstrarion guidelines`,
          items: [
            {
              type: `p`,
              text: `Our organisatiob adminstrarion guidelines`
            },
            {
              type: `p`,
              text: `Administration Guidelines for [Organization Name]`
            },
            {
              type: `p`,
              text: `Introduction:`
            },
            {
              type: `p`,
              text: `These administration guidelines are designed to provide a framework for the effective and efficient management of [Organization Name]. They outline the roles and responsibilities of administrative staff, as well as the procedures for handling various administrative tasks.`
            },
            {
              type: `p`,
              text: `Scope:`
            },
            {
              type: `p`,
              text: `These guidelines apply to all administrative staff, including secretaries, administrative assistants, and other support staff.`
            },
            {
              type: `p`,
              text: `Roles and Responsibilities:`
            },
            {
              type: `p`,
              text: `1. Administrative Manager: The Administrative Manager is responsible for overseeing the administrative functions of the organization.`
            },
            {
              type: `p`,
              text: `2. Secretaries: Secretaries are responsible for providing administrative support to their designated departments or teams.`
            },
            {
              type: `p`,
              text: `3. Administrative Assistants: Administrative Assistants provide general administrative support to the organization.`
            },
            {
              type: `p`,
              text: `Administrative Procedures:`
            },
            {
              type: `p`,
              text: `1. Correspondence: All correspondence, including letters and emails, will be handled in a professional and timely manner.`
            },
            {
              type: `p`,
              text: `2. Filing: All documents will be filed in a designated location and maintained in accordance with the organization's records management policy.`
            },
            {
              type: `p`,
              text: `3. Meetings: Meetings will be scheduled and organized in accordance with the organization's meeting procedures.`
            },
            {
              type: `p`,
              text: `4. Travel Arrangements: Travel arrangements will be made in accordance with the organization's travel policy.`
            },
            {
              type: `p`,
              text: `5. Expenses: Expenses will be reimbursed in accordance with the organization's expense reimbursement policy.`
            },
            {
              type: `p`,
              text: `Communication:`
            },
            {
              type: `p`,
              text: `1. Internal Communication: Internal communication will be conducted in a clear and respectful manner.`
            },
            {
              type: `p`,
              text: `2. External Communication: External communication will be conducted in a professional and respectful manner.`
            },
            {
              type: `p`,
              text: `Confidentiality:`
            },
            {
              type: `p`,
              text: `All administrative staff will maintain the confidentiality of sensitive information and documents.`
            },
            {
              type: `p`,
              text: `Record Keeping:`
            },
            {
              type: `p`,
              text: `All administrative records will be maintained in accordance with the organization's records management policy.`
            },
            {
              type: `p`,
              text: `Review and Update:`
            },
            {
              type: `p`,
              text: `These guidelines will be reviewed and updated annually or as needed to ensure they remain effective and relevant.`
            },
            {
              type: `p`,
              text: `Acknowledgement:`
            },
            {
              type: `p`,
              text: `All administrative staff will be required to acknowledge receipt and understanding of these guidelines.`
            },
            {
              type: `p`,
              text: `Effective Date:`
            },
            {
              type: `p`,
              text: `These guidelines are effective as of [Date] and supersede all previous guidelines.`
            },
            {
              type: `p`,
              text: `Please note that this is a general template and should be customized to fit your organization's specific needs and requirements.`
            },
            {
              type: `p`,
              text: `[7:12 م، 2025/12/16] Suhair Salah: مشروع مراكز اجتماعية للدعم النفسي لنازحي الحرب`
            },
            {
              type: `p`,
              text: `[7:12 م، 2025/12/16] Suhair Salah: مشروع مراكز اجتماعية للدعم النفسي لنازحي الحرب بمعسكر الدبة`
            },
            {
              type: `p`,
              text: `مشروع مراكز اجتماعية للدعم النفسي لنازحي الحرب بمعسكر الدبة`
            },
            {
              type: `p`,
              text: `المقدمة:`
            },
            {
              type: `p`,
              text: `يهدف هذا المشروع إلى تقديم الدعم النفسي والاجتماعي للنازحين بسبب الحرب في معسكر الدبة، حيث يواجهون تحديات نفسية واجتماعية كبيرة نتيجة للتهجير القسري والفقدان والاضطرابات النفسية.`
            },
            {
              type: `p`,
              text: `الأهداف:`
            },
            {
              type: `p`,
              text: `1. توفير الدعم النفسي: تقديم الدعم النفسي للنازحين لتحسين صحتهم النفسية ومساعدتهم على التعامل مع الصدمات النفسية.`
            },
            {
              type: `p`,
              text: `2. تعزيز التماسك الاجتماعي: تعزيز التماسك الاجتماعي بين النازحين وتحسين قدرتهم على التعامل مع التحديات اليومية.`
            },
            {
              type: `p`,
              text: `3. توفير الخدمات الاجتماعية: توفير الخدمات الاجتماعية الأساسية مثل التعليم والتدريب المهني والرعاية الصحية.`
            },
            {
              type: `p`,
              text: `الأنشطة:`
            },
            {
              type: `p`,
              text: `1. تقديم الدعم النفسي الفردي: تقديم الدعم النفسي الفردي للنازحين من قبل أخصائيين نفسيين مدربين.`
            },
            {
              type: `p`,
              text: `2. الجلسات الجماعية: تنظيم جلسات جماعية للنازحين لتعزيز التماسك الاجتماعي وتحسين مهارات التعامل مع التحديات.`
            },
            {
              type: `p`,
              text: `3. الأنشطة الترفيهية: تنظيم الأنشطة الترفيهية مثل الألعاب والفنون لتعزيز الصحة النفسية.`
            },
            {
              type: `p`,
              text: `4. التدريب المهني: توفير التدريب المهني للنازحين لتحسين فرصهم في الحصول على عمل.`
            },
            {
              type: `p`,
              text: `5. الرعاية الصحية: توفير الرعاية الصحية الأساسية للنازحين.`
            },
            {
              type: `p`,
              text: `الخطة التنفيذية:`
            },
            {
              type: `p`,
              text: `1. التخطيط والتصميم: التخطيط والتصميم للمشروع مع الفريق المعني.`
            },
            {
              type: `p`,
              text: `2. التواصل مع المجتمع: التواصل مع المجتمع المحلي والنازحين لشرح المشروع وتلقي الملاحظات.`
            },
            {
              type: `p`,
              text: `3. تنفيذ الأنشطة: تنفيذ الأنشطة المذكورة أعلاه.`
            },
            {
              type: `p`,
              text: `4. المتابعة والتقييم: متابعة وتقييم المشروع لضمان تحقيق الأهداف.`
            },
            {
              type: `p`,
              text: `التمويل:`
            },
            {
              type: `p`,
              text: `سيتم تمويل المشروع من خلال المنظمات الدولية والمنظمات غير الحكومية والجهات المانحة الأخرى.`
            },
            {
              type: `p`,
              text: `المدد الزمنية:`
            },
            {
              type: `p`,
              text: `سيتم تنفيذ المشروع على مدى 12 شهرًا.`
            },
            {
              type: `p`,
              text: `النتائج المتوقعة:`
            },
            {
              type: `p`,
              text: `1. تحسين الصحة النفسية: تحسين الصحة النفسية للنازحين.`
            },
            {
              type: `p`,
              text: `2. تعزيز التماسك الاجتماعي: تعزيز التماسك الاجتماعي بين النازحين.`
            },
            {
              type: `p`,
              text: `3. توفير الخدمات الاجتماعية: توفير الخدمات الاجتماعية الأساسية للنازحين.`
            },
            {
              type: `p`,
              text: `الخاتمة:`
            },
            {
              type: `p`,
              text: `يهدف هذا المشروع إلى تقديم الدعم النفسي والاجتماعي للنازحين بسبب الحرب في معسكر الدبة. نأمل أن يساهم هذا المشروع في تحسين حياة النازحين وتعزيز صحتهم النفسية والاجتماعية.`
            },
            {
              type: `p`,
              text: `مرحبًا!`
            },
            {
              type: `p`,
              text: `مشروع مراكز اجتماعية للدعم النفسي لنازحي الحرب هو مشروع هام يهدف إلى تقديم الدعم النفسي والاجتماعي للنازحين بسبب الحرب. إليك بعض الأفكار لتطوير هذا المشروع:`
            },
            {
              type: `p`,
              text: `الأهداف:`
            },
            {
              type: `p`,
              text: `1. توفير الدعم النفسي: تقديم الدعم النفسي للنازحين لتحسين صحتهم النفسية ومساعدتهم على التعامل مع الصدمات النفسية.`
            },
            {
              type: `p`,
              text: `2. تعزيز التماسك الاجتماعي: تعزيز التماسك الاجتماعي بين النازحين وتحسين قدرتهم على التعامل مع التحديات اليومية.`
            },
            {
              type: `p`,
              text: `3. توفير الخدمات الاجتماعية: توفير الخدمات الاجتماعية الأساسية مثل التعليم والتدريب المهني والرعاية الصحية.`
            },
            {
              type: `p`,
              text: `الأنشطة:`
            },
            {
              type: `p`,
              text: `1. تقديم الدعم النفسي الفردي: تقديم الدعم النفسي الفردي للنازحين من قبل أخصائيين نفسيين مدربين.`
            },
            {
              type: `p`,
              text: `2. الجلسات الجماعية: تنظيم جلسات جماعية للنازحين لتعزيز التماسك الاجتماعي وتحسين مهارات التعامل مع التحديات.`
            },
            {
              type: `p`,
              text: `3. الأنشطة الترفيهية: تنظيم الأنشطة الترفيهية مثل الألعاب والفنون لتعزيز الصحة النفسية.`
            },
            {
              type: `p`,
              text: `4. التدريب المهني: توفير التدريب المهني للنازحين لتحسين فرصهم في الحصول على عمل.`
            },
            {
              type: `p`,
              text: `5. الرعاية الصحية: توفير الرعاية الصحية الأساسية للنازحين.`
            },
            {
              type: `p`,
              text: `الخطة التنفيذية:`
            },
            {
              type: `p`,
              text: `1. التخطيط والتصميم: التخطيط والتصميم للمشروع مع الفريق المعني.`
            },
            {
              type: `p`,
              text: `2. التواصل مع المجتمع: التواصل مع المجتمع المحلي والنازحين لشرح المشروع وتلقي الملاحظات.`
            },
            {
              type: `p`,
              text: `3. تنفيذ الأنشطة: تنفيذ الأنشطة المذكورة أعلاه.`
            },
            {
              type: `p`,
              text: `4. المتابعة والتقييم: متابعة وتقييم المشروع لضمان تحقيق الأهداف.`
            },
            {
              type: `p`,
              text: `التمويل:`
            },
            {
              type: `p`,
              text: `سيتم تمويل المشروع من خلال المنظمات الدولية والمنظمات غير الحكومية والجهات المانحة الأخرى.`
            },
            {
              type: `p`,
              text: `المدد الزمنية:`
            },
            {
              type: `p`,
              text: `سيتم تنفيذ المشروع على مدى 12 شهرًا.`
            },
            {
              type: `p`,
              text: `النتائج المتوقعة:`
            },
            {
              type: `p`,
              text: `1. تحسين الصحة النفسية: تحسين الصحة النفسية للنازحين.`
            },
            {
              type: `p`,
              text: `2. تعزيز التماسك الاجتماعي: تعزيز التماسك الاجتماعي بين النازحين.`
            },
            {
              type: `p`,
              text: `3. توفير الخدمات الاجتماعية: توفير الخدمات الاجتماعية الأساسية للنازحين.`
            },
            {
              type: `p`,
              text: `هل هناك شيء آخر يمكنني مساعدتك به؟`
            }
          ]
        },
        {
          id: `roles-and-responsibilities`,
          title: `Roles and Responsibilities`,
          items: [
            {
              type: `p`,
              text: `بسم الله الرحمن الرحيم`
            },
            {
              type: `p`,
              text: `منظمة الخلد للاعمار والتنمية`
            },
            {
              type: `p`,
              text: `AL-KHOLD ORGNIZATION FOR 
RECONSTRACTION and DEVELOPMENT`
            },
            {
              type: `p`,
              text: `Roles and Responsibilities`
            },
            {
              type: `li`,
              text: `Management: Management is responsible for ensuring that these guidelines are implemented and enforced.`
            },
            {
              type: `li`,
              text: `Finance Team: The finance team is responsible for managing financial matters, including budgeting, accounting, and financial reporting.`
            },
            {
              type: `li`,
              text: `Human Resources Team: The human resources team is responsible for managing human resources, including recruitment, hiring, training, and employee relations.`
            },
            {
              type: `li`,
              text: `Program Team: The program team is responsible for managing programs and projects, including program design, implementation, and reporting.`
            },
            {
              type: `p`,
              text: `Monitoring and Evaluation: We will monitor and evaluate the implementation of these guidelines regularly, and make necessary adjustments to ensure effectiveness.`
            },
            {
              type: `p`,
              text: `Conclusion: These administrative guidelines outline the policies and procedures for the administration of our organization. It is essential that all staff are aware of and comply with these guidelines to ensure the efficient and effective management of our organization.`
            }
          ]
        },
        {
          id: `segregation-of-duties-and-deligation`,
          title: `segregation of duties and deligation`,
          items: [
            {
              type: `p`,
              text: `بسم الله الرحمن الرحيم`
            },
            {
              type: `p`,
              text: `منظمة الخلد للاعمار والتنمية`
            },
            {
              type: `p`,
              text: `AL-KHOLD ORGNIZATION FOR 
RECONSTRACTION and DEVELOPMENT`
            },
            {
              type: `p`,
              text: `Segregation of Duties and Delegation of Authority in Procurement Process Policy`
            },
            {
              type: `p`,
              text: `Introduction:`
            },
            {
              type: `p`,
              text: `This policy outlines the principles and procedures for segregation of duties and delegation of authority in the procurement process within our organization. The policy aims to ensure that procurement activities are conducted in a fair, transparent, and accountable manner.`
            },
            {
              type: `p`,
              text: `Scope:`
            },
            {
              type: `p`,
              text: `This policy applies to all employees, contractors, and third-party service providers involved in the procurement process.`
            },
            {
              type: `p`,
              text: `Segregation of Duties:`
            },
            {
              type: `p`,
              text: `1. Definition: Segregation of duties refers to the separation of responsibilities and duties among different individuals or departments to prevent a single person from having control over all aspects of a process or transaction.`
            },
            {
              type: `p`,
              text: `2. Principles: The following principles will guide the segregation of duties in the procurement process:`
            },
            {
              type: `p`,
              text: `- Separate responsibilities for requisition, purchasing, receiving, and payment processing.`
            },
            {
              type: `p`,
              text: `- Separate responsibilities for bid evaluation, contract award, and contract management.`
            },
            {
              type: `p`,
              text: `- Separate responsibilities for procurement planning, contract administration, and vendor management.`
            },
            {
              type: `p`,
              text: `3. Examples: Examples of segregation of duties in the procurement process include:`
            },
            {
              type: `p`,
              text: `- Requisitioning: separate responsibilities for requisition initiation, approval, and procurement processing.`
            },
            {
              type: `p`,
              text: `- Tendering: separate responsibilities for tender preparation, evaluation, and award.`
            },
            {
              type: `p`,
              text: `Delegation of Authority:`
            },
            {
              type: `p`,
              text: `1. Definition: Delegation of authority refers to the transfer of authority from one individual or department to another to perform specific tasks or make decisions.`
            },
            {
              type: `p`,
              text: `2. Principles: The following principles will guide the delegation of authority in the procurement process:`
            },
            {
              type: `p`,
              text: `- Authority will be delegated in writing.`
            },
            {
              type: `p`,
              text: `- Authority will be delegated to individuals who have the necessary skills, knowledge, and experience.`
            },
            {
              type: `p`,
              text: `- Authority will be reviewed and updated regularly.`
            },
            {
              type: `p`,
              text: `3. Levels of Authority: The following levels of authority will apply to the procurement process:`
            },
            {
              type: `p`,
              text: `- Level 1: Approval of procurement requests up to [insert amount].`
            },
            {
              type: `p`,
              text: `- Level 2: Approval of procurement requests up to [insert amount].`
            },
            {
              type: `p`,
              text: `- Level 3: Approval of procurement requests above [insert amount].`
            },
            {
              type: `p`,
              text: `Roles and Responsibilities:`
            },
            {
              type: `p`,
              text: `1. Procurement Committee: The procurement committee will oversee the procurement process and ensure that segregation of duties and delegation of authority are implemented.`
            },
            {
              type: `p`,
              text: `2. Procurement Officer: The procurement officer will manage the procurement process and ensure that segregation of duties and delegation of authority are implemented.`
            },
            {
              type: `p`,
              text: `3. Requisitioning Department: The requisitioning department will initiate procurement requests and ensure that segregation of duties is maintained.`
            },
            {
              type: `p`,
              text: `Best Practices:`
            },
            {
              type: `p`,
              text: `1. Conduct Risk Assessment: Conduct a risk assessment to identify areas where segregation of duties and delegation of authority are necessary in the procurement process.`
            },
            {
              type: `p`,
              text: `2. Document Procedures: Document procedures and responsibilities for the procurement process.`
            },
            {
              type: `p`,
              text: `3. Monitor and Review: Monitor and review segregation of duties and delegation of authority in the procurement process regularly.`
            },
            {
              type: `p`,
              text: `4. Provide Training: Provide training to employees on segregation of duties and delegation of authority in the procurement process.`
            },
            {
              type: `p`,
              text: `Procurement Process Flow:`
            },
            {
              type: `p`,
              text: `1. Requisition: The requisitioning department initiates a procurement request.`
            },
            {
              type: `p`,
              text: `2. Approval: The procurement request is approved by the designated authority.`
            },
            {
              type: `p`,
              text: `3. Tendering: The procurement officer initiates the tendering process.`
            },
            {
              type: `p`,
              text: `4. Evaluation: The bid evaluation committee evaluates the tenders.`
            },
            {
              type: `p`,
              text: `5. Award: The contract is awarded to the successful bidder.`
            },
            {
              type: `p`,
              text: `6. Contract Management: The contract is managed by the procurement officer.`
            },
            {
              type: `p`,
              text: `Conclusion:`
            },
            {
              type: `p`,
              text: `This policy outlines the principles and procedures for segregation of duties and delegation of authority in the procurement process within our organization. It aims to ensure that procurement activities are conducted in a fair, transparent, and accountable manner.`
            }
          ]
        },
        {
          id: `internal-audit-functions`,
          title: `Internal Audit Functions`,
          items: [
            {
              type: `p`,
              text: `بسم الله الرحمن الرحيم`
            },
            {
              type: `p`,
              text: `منظمة الخلد للاعمار والتنمية`
            },
            {
              type: `p`,
              text: `AL-KHOLD ORGNIZATION FOR 
RECONSTRACTION and DEVELOPMENT`
            },
            {
              type: `p`,
              text: `Internal Audit Functions`
            },
            {
              type: `p`,
              text: `Introduction:`
            },
            {
              type: `p`,
              text: `Internal audit is an independent and objective function that provides assurance and consulting services to our organization. The internal audit function helps our organization to achieve its objectives by evaluating and improving the effectiveness of its risk management, control, and governance processes.`
            },
            {
              type: `p`,
              text: `Scope:`
            },
            {
              type: `p`,
              text: `The internal audit function will cover all aspects of our organization's operations, including:`
            },
            {
              type: `li`,
              text: `Financial Management: Review of financial statements, accounting policies, and procedures.`
            },
            {
              type: `li`,
              text: `Operational Management: Review of operational processes, systems, and controls.`
            },
            {
              type: `li`,
              text: `Compliance: Review of compliance with laws, regulations, and policies.`
            },
            {
              type: `li`,
              text: `Governance: Review of governance structures, processes, and controls.`
            },
            {
              type: `p`,
              text: `Internal Audit Responsibilities:`
            },
            {
              type: `li`,
              text: `Risk Assessment: Identify and assess risks facing our organization.`
            },
            {
              type: `li`,
              text: `Audit Planning: Develop an annual audit plan based on the risk assessment.`
            },
            {
              type: `li`,
              text: `Audit Execution: Conduct audits in accordance with the audit plan.`
            },
            {
              type: `li`,
              text: `Reporting: Report audit findings and recommendations to management and the audit committee.`
            },
            {
              type: `li`,
              text: `Follow-up: Follow up on the implementation of audit recommendations.`
            },
            {
              type: `p`,
              text: `Internal Audit Activities:`
            },
            {
              type: `li`,
              text: `Financial Audit: Review of financial statements and accounting records.`
            },
            {
              type: `li`,
              text: `Operational Audit: Review of operational processes and systems`
            },
            {
              type: `li`,
              text: `Compliance Audit: Review of compliance with laws, regulations, and policies.`
            },
            {
              type: `li`,
              text: `Special Reviews: Conduct special reviews and investigations as requested by management or the audit committee.`
            },
            {
              type: `p`,
              text: `Roles and Responsibilities:`
            },
            {
              type: `li`,
              text: `Internal Audit Manager: Manage the internal audit function and report to the audit committee.`
            },
            {
              type: `li`,
              text: `Audit Staff: Conduct audits and provide recommendations for improvement.`
            },
            {
              type: `li`,
              text: `Management: Implement audit recommendations and provide feedback to the internal audit function.`
            },
            {
              type: `p`,
              text: `Audit Committee: Oversee the internal audit function and ensure its independence and effectiveness.`
            },
            {
              type: `p`,
              text: `Best Practices:`
            },
            {
              type: `li`,
              text: `Independence: Ensure the internal audit function is independent and objective.`
            },
            {
              type: `li`,
              text: `Professional Standards: Follow professional standards and guidelines for internal auditing.`
            },
            {
              type: `li`,
              text: `Communication: Communicate audit findings and recommendations clearly and timely.`
            },
            {
              type: `li`,
              text: `Follow-up: Follow up on the implementation of audit recommendations.`
            },
            {
              type: `p`,
              text: `Conclusion:`
            },
            {
              type: `p`,
              text: `The internal audit function is an essential part of our organization's governance structure. It provides assurance and consulting services to help our organization achieve its objectives.`
            }
          ]
        },
        {
          id: `risk-management-doc`,
          title: `risk management doc`,
          items: [
            {
              type: `p`,
              text: `بسم الله الرحمن الرحيم`
            },
            {
              type: `p`,
              text: `منظمة الخلد للاعمار والتنمية`
            },
            {
              type: `p`,
              text: `Alkhold Organization for Reconstruction & Development`
            },
            {
              type: `p`,
              text: `Risk Management Document`
            },
            {
              type: `p`,
              text: `Risk Management Document – Alkhold Organization for Reconstruction & Development`
            },
            {
              type: `p`,
              text: `_Humanitarian Aid: Health, Shelter & Food Programs_`
            },
            {
              type: `p`,
              text: `1. Introduction`
            },
            {
              type: `p`,
              text: `Alkhold Organization delivers emergency health services, temporary shelter, and food assistance in crisis-affected regions. This document outlines the risk-management framework to protect staff, beneficiaries, partners, and the organization’s reputation and assets.`
            },
            {
              type: `p`,
              text: `2. Definitions`
            },
            {
              type: `p`,
              text: `- Risk:  Any event that could impede program delivery or cause harm.`
            },
            {
              type: `p`,
              text: `- Likelihood: Probability of occurrence (Rare, Unlikely, Possible, Likely, Almost Certain).`
            },
            {
              type: `p`,
              text: `- Impact: Consequence on safety, finances, operations, or reputation (Negligible, Minor, Moderate, Major, Critical).`
            },
            {
              type: `p`,
              text: `- Risk Level: Combination of likelihood × impact (Low, Medium, High, Very High).`
            },
            {
              type: `p`,
              text: `3. Risk Identification – Core Areas`
            },
            {
              type: `p`,
              text: `Category Typical Risks (examples)`
            },
            {
              type: `p`,
              text: `Security Armed conflict, kidnapping, road ambushes, mine-field exposure`
            },
            {
              type: `p`,
              text: `Health Disease outbreaks, inadequate medical supplies, staff injuries`
            },
            {
              type: `p`,
              text: `Shelter Poor site selection, structural collapse, fire hazards`
            },
            {
              type: `p`,
              text: `Food Distribution Spoilage, theft, mismanagement of vouchers`
            },
            {
              type: `p`,
              text: `Operational Logistic delays, IT failures, funding shortfalls`
            },
            {
              type: `p`,
              text: `Legal/Compliance Permits, beneficiary data protection, anti-fraud regulations`
            },
            {
              type: `p`,
              text: `Environmental Natural disasters (floods, earthquakes), climate-related hazards`
            },
            {
              type: `p`,
              text: `4. Risk Assessment (Sample Matrix)`
            },
            {
              type: `p`,
              text: `Risk Likelihood Impact Risk Level Mitigation Summary`
            },
            {
              type: `p`,
              text: `Road ambush during field travel Possible Major High Route planning, convoy security, GPS tracking`
            },
            {
              type: `p`,
              text: `Cholera outbreak in camps Unlikely Critical High Water-sanitation monitoring, rapid response kits`
            },
            {
              type: `p`,
              text: `Shelter fire Rare Major Medium Fire-breaks, training, fire extinguishers`
            },
            {
              type: `p`,
              text: `Food spoilage due to power loss Possible Moderate Medium Cold-chain backup generators, inventory rotation`
            },
            {
              type: `p`,
              text: `Funding gap >30% Likely Major High Diversified donor base, cash-flow forecasting`
            },
            {
              type: `p`,
              text: `_(Replace with organization-specific data.)_`
            },
            {
              type: `p`,
              text: `5. Mitigation Strategies`
            },
            {
              type: `p`,
              text: `1. Security Management`
            },
            {
              type: `p`,
              text: `- Conduct context analysis before deployment.`
            },
            {
              type: `p`,
              text: `- Provide staff with security briefings and personal protective equipment.`
            },
            {
              type: `p`,
              text: `- Use third-party security escorts where needed.`
            },
            {
              type: `p`,
              text: `2. Health Safety`
            },
            {
              type: `p`,
              text: `- Maintain up-to-date medical kits and vaccination records.`
            },
            {
              type: `p`,
              text: `- Implement infection-control protocols (hand-washing stations, PPE).`
            },
            {
              type: `p`,
              text: `3. *Shelter & Infrastructure*`
            },
            {
              type: `p`,
              text: `- Site selection based on hazard maps.`
            },
            {
              type: `p`,
              text: `- Regular structural inspections; fire-safety drills.`
            },
            {
              type: `p`,
              text: `4. *Food & Nutrition*`
            },
            {
              type: `p`,
              text: `- Adopt FIFO (first-in-first-out) stock management.`
            },
            {
              type: `p`,
              text: `- Monitor temperature logs for cold-chain items.`
            },
            {
              type: `p`,
              text: `5. *Operational Resilience*`
            },
            {
              type: `p`,
              text: `- Cloud-based data backup; remote work capability.`
            },
            {
              type: `p`,
              text: `- Pre-negotiated contracts with local suppliers.`
            },
            {
              type: `p`,
              text: `6. *Legal & Compliance*`
            },
            {
              type: `p`,
              text: `- Maintain a compliance checklist for each country of operation.`
            },
            {
              type: `p`,
              text: `- Train staff on data-privacy standards (e.g., GDPR-like).`
            },
            {
              type: `p`,
              text: `6. Monitoring & Review`
            },
            {
              type: `p`,
              text: `- Monthly: Risk register update; review of incident reports.`
            },
            {
              type: `p`,
              text: `- *Quarterly: Risk-level reassessment with program managers.`
            },
            {
              type: `p`,
              text: `- Annually: Full risk-management audit and policy refresh.`
            },
            {
              type: `p`,
              text: `All changes are recorded in the _Risk Register_`
            },
            {
              type: `p`,
              text: `7. Training & Awareness`
            },
            {
              type: `p`,
              text: `- Mandatory induction for new staff (security, health, safeguarding).`
            },
            {
              type: `p`,
              text: `- Bi-annual refresher workshops on fire safety and epidemic response.`
            },
            {
              type: `p`,
              text: `- Simulation exercises for shelter fire and disease outbreak scenarios.`
            },
            {
              type: `p`,
              text: `8. Documentation & Reporting`
            },
            {
              type: `p`,
              text: `- Incident Report Form – completed within 24 hours of any event.`
            },
            {
              type: `p`,
              text: `- Risk Register – centralized spreadsheet with owner, status, and deadline.`
            },
            {
              type: `p`,
              text: `- Annual Risk Management Report– submitted to the Board and donors.`
            }
          ]
        },
        {
          id: `transparency-policy`,
          title: `Transparency Policy`,
          items: [
            {
              type: `p`,
              text: `بسم الله الرحمن الرحيم`
            },
            {
              type: `p`,
              text: `منظمة الخلد للاعمار والتنمية`
            },
            {
              type: `p`,
              text: `AL-KHOLD ORGNIZATION FOR 
RECONSTRACTION and DEVELOPMENT`
            },
            {
              type: `p`,
              text: `Transparency Policy`
            },
            {
              type: `p`,
              text: `Introduction:`
            },
            {
              type: `p`,
              text: `Al-khold Organization for Reconstruction and Development  is committed to transparency and accountability in all its operations. This transparency policy outlines our commitment to openness and transparency in our decision-making processes, financial management, and program implementation.`
            },
            {
              type: `p`,
              text: `Scope:`
            },
            {
              type: `p`,
              text: `This policy applies to all staff, including employees, consultants, and volunteers, as well as partners, stakeholders, and the general public.`
            },
            {
              type: `p`,
              text: `Transparency Principles:`
            },
            {
              type: `li`,
              text: `Openness: We will be open and transparent in our decision-making processes and operations.`
            },
            {
              type: `li`,
              text: `Accountability: We will be accountable for our actions and decisions.`
            },
            {
              type: `li`,
              text: `Responsiveness: We will respond to requests for information and provide timely and accurate information.`
            },
            {
              type: `li`,
              text: `Fairness: We will ensure that our operations are fair and equitable.`
            },
            {
              type: `p`,
              text: `Transparency Practices:`
            },
            {
              type: `li`,
              text: `Disclosure of Information: We will disclose information about our operations, programs, and financial management.`
            },
            {
              type: `li`,
              text: `Annual Reports: We will publish annual reports that provide an overview of our activities and financial performance.`
            },
            {
              type: `li`,
              text: `Financial Statements: We will publish financial statements that provide detailed information about our income and expenditures.`
            },
            {
              type: `li`,
              text: `Program Reports: We will publish program reports that provide information about our program activities and outcomes.`
            },
            {
              type: `li`,
              text: `Website: We will maintain a website that provides information about our organization, programs, and activities.`
            },
            {
              type: `p`,
              text: `Access to Information:`
            },
            {
              type: `li`,
              text: `Requests for Information: We will respond to requests for information in a timely and accurate manner.`
            },
            {
              type: `li`,
              text: `Freedom of Information: We will comply with freedom of information laws and regulations.`
            },
            {
              type: `li`,
              text: `Data Protection: We will protect personal data and ensure that it is not disclosed without consent.`
            },
            {
              type: `p`,
              text: `Roles and Responsibilities:`
            },
            {
              type: `li`,
              text: `Management: Management is responsible for ensuring that this policy is implemented and enforced.`
            },
            {
              type: `li`,
              text: `Communications Team: The communications team is responsible for managing our website, social media, and other communication channels.`
            },
            {
              type: `li`,
              text: `Finance Team: The finance team is responsible for managing our financial statements and reports.`
            },
            {
              type: `li`,
              text: `Program Team: The program team is responsible for managing our program reports and information.`
            },
            {
              type: `p`,
              text: `Monitoring and Evaluation:`
            },
            {
              type: `p`,
              text: `We will monitor and evaluate the implementation of this policy regularly, and make necessary adjustments to ensure effectiveness.`
            },
            {
              type: `p`,
              text: `Conclusion:`
            },
            {
              type: `p`,
              text: `Our organization is committed to transparency and accountability in all its operations. This transparency policy outlines our commitment to openness and transparency, and provides a framework for ensuring that we are accountable to our stakeholders.`
            }
          ]
        },
        {
          id: `framework-for-accountability-to-affected-populations-introduction`,
          title: `Framework for Accountability to Affected Populations Introduction`,
          items: [
            {
              type: `p`,
              text: `بسم الله الرحمن الرحيم`
            },
            {
              type: `p`,
              text: `منظمة الخلد للاعمار والتنمية`
            },
            {
              type: `p`,
              text: `AL-KHOLD ORGNIZATION FOR 
RECONSTRACTION and DEVELOPMENT`
            },
            {
              type: `p`,
              text: `Framework for Accountability to Affected Populations Introduction:`
            },
            {
              type: `p`,
              text: `This framework aims to provide a structure for accountability to affected populations in humanitarian and development operations. It focuses on ensuring that accountability is a core component of these operations and that affected populations are at the center of these processes.`
            },
            {
              type: `p`,
              text: `Core Principles:`
            },
            {
              type: `li`,
              text: `Participation: Affected populations must be involved in all stages of humanitarian and development operations.`
            },
            {
              type: `li`,
              text: `Transparency: Information about humanitarian and development operations must be accessible to affected populations.`
            },
            {
              type: `li`,
              text: `Accountability: Those responsible for humanitarian and development operations must be accountable to affected populations.`
            },
            {
              type: `li`,
              text: `Respect: Affected populations must be treated with respect and dignity.`
            },
            {
              type: `p`,
              text: `Key Processes:`
            },
            {
              type: `li`,
              text: `Planning: Humanitarian and development operations must be planned with the participation of affected populations.`
            },
            {
              type: `li`,
              text: `Implementation: Humanitarian and development operations must be implemented in a transparent and accountable manner.`
            },
            {
              type: `li`,
              text: `Monitoring: Humanitarian and development operations must be monitored to ensure they are implemented in a transparent and accountable manner.`
            },
            {
              type: `li`,
              text: `Evaluation: Humanitarian and development operations must be evaluated to ensure they achieve their objectives.`
            },
            {
              type: `p`,
              text: `Mechanisms:`
            },
            {
              type: `li`,
              text: `Advisory Committees: Advisory committees comprising representatives of affected populations must be established.`
            },
            {
              type: `li`,
              text: `Surveys: Surveys must be conducted to measure the satisfaction of affected populations with humanitarian and development operations.`
            },
            {
              type: `li`,
              text: `Reviews: Regular reviews of humanitarian and development operations must be conducted.`
            },
            {
              type: `li`,
              text: `Reports: Regular reports on humanitarian and development operations must be provided.`
            },
            {
              type: `p`,
              text: `Expected Outcomes:`
            },
            {
              type: `li`,
              text: `Improved Accountability: This framework should lead to improved accountability to affected populations.`
            },
            {
              type: `li`,
              text: `Increased Participation: This framework should lead to increased participation of affected populations in humanitarian and development operations.`
            },
            {
              type: `li`,
              text: `Enhanced Transparency: This framework should lead to enhanced transparency in humanitarian and development operations.`
            },
            {
              type: `p`,
              text: `Conclusion: This framework aims to provide a structure for accountability to affected populations in humanitarian and development operations. It must be implemented in a transparent and accountable manner to ensure that accountability is a core component of these operations.`
            }
          ]
        }
      ]
    },
    {
      title: `Human Resources & Safeguarding`,
      slug: `human-resources-safeguarding`,
      docs: [
        {
          id: `personnel-guideline`,
          title: `Personnel Guideline`,
          items: [
            {
              type: `p`,
              text: `بسم الله الرحمن الرحيم`
            },
            {
              type: `p`,
              text: `منظمة الخلد للاعمار والتنمية`
            },
            {
              type: `p`,
              text: `AL-KHOLD ORGNIZATION FOR 
RECONSTRACTION and DEVELOPMENT`
            },
            {
              type: `p`,
              text: `Personnel Guideline`
            },
            {
              type: `p`,
              text: `Introduction:`
            },
            {
              type: `p`,
              text: `This guideline outlines the personnel policies and procedures for our organization. It is essential to ensure that all staff are aware of and comply with these policies to maintain a positive and productive work environment. Scope: This guideline applies to all staff, including employees, consultants, and volunteers. Personnel Policies:`
            },
            {
              type: `li`,
              text: `Recruitment and Hiring: Our organization is committed to equal employment opportunities and will recruit and hire staff based on merit and qualifications.`
            },
            {
              type: `li`,
              text: `Job Descriptions: Job descriptions will be provided to all staff, outlining their roles, responsibilities, and expectations.`
            },
            {
              type: `li`,
              text: `Performance Management: Staff will receive regular performance evaluations and feedback to ensure they are meeting expectations.`
            },
            {
              type: `li`,
              text: `Training and Development: Our organization will provide training and development opportunities to staff to enhance their skills and knowledge.`
            },
            {
              type: `li`,
              text: `Employee Conduct: Staff are expected to maintain a high level of professionalism and conduct themselves in a manner that reflects positively on the organization.`
            },
            {
              type: `li`,
              text: `Confidentiality: Staff will maintain confidentiality of sensitive information and respect the privacy of colleagues, partners, and beneficiaries.`
            },
            {
              type: `li`,
              text: `Conflict of Interest: Staff will avoid conflicts of interest and disclose any potential conflicts to management.`
            },
            {
              type: `li`,
              text: `Health and Safety: Our organization is committed to providing a safe and healthy work environment for all staff.`
            }
          ]
        },
        {
          id: `personal-guideline`,
          title: `personal guideline`,
          items: [
            {
              type: `p`,
              text: `بسم الله الرحمن الرحيم`
            },
            {
              type: `p`,
              text: `منظمة الخلد للاعمار والتنمية`
            },
            {
              type: `p`,
              text: `AL-KHOLD ORGNIZATION FOR 
RECONSTRACTION and DEVELOPMENT`
            },
            {
              type: `p`,
              text: `personal guide line`
            },
            {
              type: `p`,
              text: `AL-KHOLD ORGNIZATION FOR RECONSTRACTION and DEVELOPMENT organization,  has developed a personal guide line which can be a valuable resource for individuals seeking to improve their productivity, time management, and goal-setting skills. Here are some ways a personal guide line can support organization: it is a part of our training foe our employees.`
            },
            {
              type: `p`,
              text: `1. Goal-setting: A personal guide can help individuals set and achieve goals, breaking them down into smaller, manageable tasks.`
            },
            {
              type: `p`,
              text: `2. Prioritization: A guide can assist with prioritizing tasks, focusing on the most important and urgent ones first.`
            },
            {
              type: `p`,
              text: `3. Time management: A personal guide can provide strategies for effective time management, including scheduling and avoiding procrastination.`
            },
            {
              type: `p`,
              text: `4. Organization systems: A guide can help individuals develop systems for organizing their physical and digital spaces, including file management and decluttering.`
            },
            {
              type: `p`,
              text: `5. Accountability: Regular check-ins with a personal guide can provide accountability and motivation to stay on track.`
            },
            {
              type: `p`,
              text: `Some popular tools and resources for organization include:`
            },
            {
              type: `p`,
              text: `1. To-do lists: Apps like Todoist, Trello, or Wunderlist can help manage tasks and prioritize activities.`
            },
            {
              type: `p`,
              text: `2. Calendars: Google Calendar, Apple Calendar, or Microsoft Outlook can help schedule appointments and events.`
            },
            {
              type: `p`,
              text: `3. Note-taking apps: Evernote, OneNote, or Simplenote can help organize notes and ideas.`
            },
            {
              type: `p`,
              text: `4. Task management software: Asana, Basecamp, or Jira can help manage projects and tasks.`
            }
          ]
        },
        {
          id: `policies-and-procedures-to-prevent-sexual-exploitation-and-abuse-introduction`,
          title: `Policies and Procedures to Prevent Sexual Exploitation and Abuse Introduction`,
          items: [
            {
              type: `p`,
              text: `بسم الله الرحمن الرحيم`
            },
            {
              type: `p`,
              text: `منظمة الخلد للاعمار والتنمية`
            },
            {
              type: `p`,
              text: `AL-KHOLD ORGNIZATION FOR 
RECONSTRACTION and DEVELOPMENT`
            },
            {
              type: `p`,
              text: `Policies and Procedures to Prevent Sexual Exploitation and Abuse Introduction:`
            },
            {
              type: `p`,
              text: `This document outlines the policies and procedures to prevent sexual exploitation and abuse (SEA) in humanitarian and development operations. It is essential to create a safe and respectful environment for all individuals, particularly those who are most vulnerable.`
            },
            {
              type: `p`,
              text: `Policy Statement: Al-khuld Organization for reconstruction and development is committed to preventing sexual exploitation and abuse in all its operations. We will not tolerate any form of SEA and will take all necessary measures to prevent, detect, and respond to SEA incidents.`
            },
            {
              type: `p`,
              text: `Scope: This policy applies to all staff, partners, volunteers, and anyone working on behalf of our organization.`
            },
            {
              type: `p`,
              text: `Definitions:`
            },
            {
              type: `li`,
              text: `Sexual Exploitation: Any actual or attempted abuse of a position of vulnerability, differential power, or trust, for sexual purposes, including the exchange of money, employment, goods, or services.`
            },
            {
              type: `li`,
              text: `Sexual Abuse: Any actual or threatened physical intrusion of a sexual nature, whether by force or under unequal or coercive conditions.`
            },
            {
              type: `p`,
              text: `Policies:`
            },
            {
              type: `li`,
              text: `Zero Tolerance: Our organization has a zero-tolerance policy towards SEA.`
            },
            {
              type: `li`,
              text: `Prevention: We will take all necessary measures to prevent SEA, including training, awareness-raising, and vetting of staff and partners.`
            },
            {
              type: `li`,
              text: `Reporting: We will ensure that all SEA incidents are reported and investigated promptly, and that survivors receive support and protection.`
            },
            {
              type: `li`,
              text: `Accountability: We will hold individuals accountable for SEA, and take disciplinary action, including termination of employment or contract, and referral to law enforcement authorities.`
            },
            {
              type: `p`,
              text: `Procedures:`
            },
            {
              type: `li`,
              text: `Reporting Mechanisms: We will establish safe and accessible reporting mechanisms for SEA incidents, including a confidential hotline and email address.`
            },
            {
              type: `li`,
              text: `Investigation: We will investigate all SEA incidents promptly, thoroughly, and impartially, and take action to prevent further harm.`
            },
            {
              type: `li`,
              text: `Support and Protection: We will provide support and protection to survivors of SEA, including medical, psychosocial, and legal assistance.`
            },
            {
              type: `li`,
              text: `Training and Awareness: We will provide training and awareness-raising activities for staff, partners, and beneficiaries on SEA prevention and response.`
            },
            {
              type: `p`,
              text: `Roles and Responsibilities:`
            },
            {
              type: `li`,
              text: `Management: Management is responsible for ensuring that this policy is implemented and enforced.`
            },
            {
              type: `li`,
              text: `Human Resources: Human Resources is responsible for ensuring that all staff are aware of and comply with this policy.`
            },
            {
              type: `li`,
              text: `Protection Team: The Protection Team is responsible for providing support and protection to survivors of SEA.`
            },
            {
              type: `p`,
              text: `Monitoring and Evaluation: We will monitor and evaluate the implementation of this policy and procedures regularly, and make necessary adjustments to ensure effectiveness. Conclusion: Preventing SEA is a collective responsibility. We are committed to creating a safe and respectful environment for all individuals, and we expect all staff, partners, and beneficiaries to adhere to this policy.`
            }
          ]
        },
        {
          id: `policies-and-procedures-to-prevent-sexual-exploitation-and-abuse`,
          title: `Policies and Procedures to Prevent Sexual Exploitation and Abuse`,
          items: [
            {
              type: `p`,
              text: `Policies and Procedures to Prevent Sexual Exploitation and Abuse`
            },
            {
              type: `p`,
              text: `Introduction:`
            },
            {
              type: `p`,
              text: `This document outlines the policies and procedures to prevent sexual exploitation and abuse (SEA) in humanitarian and development operations. It is essential to create a safe and respectful environment for all individuals, particularly those who are most vulnerable.`
            },
            {
              type: `p`,
              text: `Policy Statement:`
            },
            {
              type: `p`,
              text: `Our organization is committed to preventing sexual exploitation and abuse in all its operations. We will not tolerate any form of SEA and will take all necessary measures to prevent, detect, and respond to SEA incidents.`
            },
            {
              type: `p`,
              text: `Scope:`
            },
            {
              type: `p`,
              text: `This policy applies to all staff, partners, volunteers, and anyone working on behalf of our organization.`
            },
            {
              type: `p`,
              text: `Definitions:`
            },
            {
              type: `p`,
              text: `- Sexual Exploitation: Any actual or attempted abuse of a position of vulnerability, differential power, or trust, for sexual purposes, including the exchange of money, employment, goods, or services.`
            },
            {
              type: `p`,
              text: `- Sexual Abuse: Any actual or threatened physical intrusion of a sexual nature, whether by force or under unequal or coercive conditions.`
            },
            {
              type: `p`,
              text: `Policies:`
            },
            {
              type: `p`,
              text: `1. Zero Tolerance: Our organization has a zero-tolerance policy towards SEA.`
            },
            {
              type: `p`,
              text: `2. Prevention: We will take all necessary measures to prevent SEA, including training, awareness-raising, and vetting of staff and partners.`
            },
            {
              type: `p`,
              text: `3. Reporting: We will ensure that all SEA incidents are reported and investigated promptly, and that survivors receive support and protection.`
            },
            {
              type: `p`,
              text: `4. Accountability: We will hold individuals accountable for SEA, and take disciplinary action, including termination of employment or contract, and referral to law enforcement authorities.`
            },
            {
              type: `p`,
              text: `Procedures:`
            },
            {
              type: `p`,
              text: `1. Reporting Mechanisms: We will establish safe and accessible reporting mechanisms for SEA incidents, including a confidential hotline and email address.`
            },
            {
              type: `p`,
              text: `2. Investigation: We will investigate all SEA incidents promptly, thoroughly, and impartially, and take action to prevent further harm.`
            },
            {
              type: `p`,
              text: `3. Support and Protection: We will provide support and protection to survivors of SEA, including medical, psychosocial, and legal assistance.`
            },
            {
              type: `p`,
              text: `4. Training and Awareness: We will provide training and awareness-raising activities for staff, partners, and beneficiaries on SEA prevention and response.`
            },
            {
              type: `p`,
              text: `Roles and Responsibilities:`
            },
            {
              type: `p`,
              text: `1. Management: Management is responsible for ensuring that this policy is implemented and enforced.`
            },
            {
              type: `p`,
              text: `2. Human Resources: Human Resources is responsible for ensuring that all staff are aware of and comply with this policy.`
            },
            {
              type: `p`,
              text: `3. Protection Team: The Protection Team is responsible for providing support and protection to survivors of SEA.`
            },
            {
              type: `p`,
              text: `Monitoring and Evaluation:`
            },
            {
              type: `p`,
              text: `We will monitor and evaluate the implementation of this policy and procedures regularly, and make necessary adjustments to ensure effectiveness.`
            },
            {
              type: `p`,
              text: `Conclusion:`
            },
            {
              type: `p`,
              text: `Preventing SEA is a collective responsibility. We are committed to creating a safe and respectful environment for all individuals, and we expect all staff, partners, and beneficiaries to adhere to this policy.`
            }
          ]
        },
        {
          id: `polices-and-procedures-prevent-sea`,
          title: `polices and procedures prevent SEA`,
          items: [
            {
              type: `p`,
              text: `بسم الله الرحمن الرحيم`
            },
            {
              type: `p`,
              text: `منظمة الخلد للاعمار والتنمية`
            },
            {
              type: `p`,
              text: `AL-KHOLD ORGNIZATION FOR 
RECONSTRACTION and DEVELOPMENT`
            },
            {
              type: `p`,
              text: `Policies and Procedures to Prevent Sexual Exploitation and Abuse`
            },
            {
              type: `p`,
              text: `Introduction:`
            },
            {
              type: `p`,
              text: `This document outlines the policies and procedures to prevent sexual exploitation and abuse (SEA) in humanitarian and development operations. It is essential to create a safe and respectful environment for all individuals, particularly those who are most vulnerable.`
            },
            {
              type: `p`,
              text: `Policy Statement:`
            },
            {
              type: `p`,
              text: `Al-khold organization for reconstruction and development is committed to preventing sexual exploitation and abuse in all its operations. We will not tolerate any form of SEA and will take all necessary measures to prevent, detect, and respond to SEA incidents.`
            },
            {
              type: `p`,
              text: `Scope:`
            },
            {
              type: `p`,
              text: `This policy applies to all staff, partners, volunteers, and anyone working on behalf of our organization.`
            },
            {
              type: `p`,
              text: `Definitions:`
            },
            {
              type: `p`,
              text: `- Sexual Exploitation: Any actual or attempted abuse of a position of vulnerability, differential power, or trust, for sexual purposes, including the exchange of money, employment, goods, or services.`
            },
            {
              type: `p`,
              text: `- Sexual Abuse: Any actual or threatened physical intrusion of a sexual nature, whether by force or under unequal or coercive conditions.`
            },
            {
              type: `p`,
              text: `Policies:`
            },
            {
              type: `p`,
              text: `1. Zero Tolerance: Our organization has a zero-tolerance policy towards SEA.`
            },
            {
              type: `p`,
              text: `2. Prevention: We will take all necessary measures to prevent SEA, including training, awareness-raising, and vetting of staff and partners.`
            },
            {
              type: `p`,
              text: `3. Reporting: We will ensure that all SEA incidents are reported and investigated promptly, and that survivors receive support and protection.`
            },
            {
              type: `p`,
              text: `4. Accountability: We will hold individuals accountable for SEA, and take disciplinary action, including termination of employment or contract, and referral to law enforcement authorities.`
            },
            {
              type: `p`,
              text: `Procedures:`
            },
            {
              type: `p`,
              text: `1. Reporting Mechanisms: We will establish safe and accessible reporting mechanisms for SEA incidents, including a confidential hotline and email address.`
            },
            {
              type: `p`,
              text: `2. Investigation: We will investigate all SEA incidents promptly, thoroughly, and impartially, and take action to prevent further harm.`
            },
            {
              type: `p`,
              text: `3. Support and Protection: We will provide support and protection to survivors of SEA, including medical, psychosocial, and legal assistance.`
            },
            {
              type: `p`,
              text: `4. Training and Awareness: We will provide training and awareness-raising activities for staff, partners, and beneficiaries on SEA prevention and response.`
            },
            {
              type: `p`,
              text: `Roles and Responsibilities:`
            },
            {
              type: `p`,
              text: `1. Management: Management is responsible for ensuring that this policy is implemented and enforced.`
            },
            {
              type: `p`,
              text: `2. Human Resources: Human Resources is responsible for ensuring that all staff are aware of and comply with this policy.`
            },
            {
              type: `p`,
              text: `3. Protection Team: The Protection Team is responsible for providing support and protection to survivors of SEA.`
            },
            {
              type: `p`,
              text: `Monitoring and Evaluation:`
            },
            {
              type: `p`,
              text: `We will monitor and evaluate the implementation of this policy and procedures regularly, and make necessary adjustments to ensure effectiveness.`
            },
            {
              type: `p`,
              text: `Conclusion:`
            },
            {
              type: `p`,
              text: `Preventing SEA is a collective responsibility. We are committed to creating a safe and respectful environment for all individuals, and we expect all staff, partners, and beneficiaries to adhere to this policy.`
            }
          ]
        }
      ]
    },
    {
      title: `Security & Safety`,
      slug: `security-safety`,
      docs: [
        {
          id: `driving-security-and-safety-policy`,
          title: `Driving Security and Safety Policy`,
          items: [
            {
              type: `p`,
              text: `بسم الله الرحمن الرحيم`
            },
            {
              type: `p`,
              text: `منظمة الخلد للاعمار والتنمية`
            },
            {
              type: `p`,
              text: `AL-KHOLD ORGNIZATION FOR 
RECONSTRACTION and DEVELOPMENT`
            },
            {
              type: `p`,
              text: `Al-khold organization for reconstruction and development Driving Security and Safety Policy`
            },
            {
              type: `p`,
              text: `Introduction:`
            },
            {
              type: `p`,
              text: `This policy aims to ensure the safety and security of all employees and drivers who drive organization vehicles or use them for work purposes. We believe that road safety is a shared responsibility among all employees and drivers.`
            },
            {
              type: `p`,
              text: `Scope:`
            },
            {
              type: `p`,
              text: `This policy applies to all employees and drivers who drive organization vehicles or use them for work purposes.`
            },
            {
              type: `p`,
              text: `Objectives:`
            },
            {
              type: `li`,
              text: `Reduce Accidents: Reduce the number of road accidents that occur while driving for work purposes`
            },
            {
              type: `li`,
              text: `Protect Employees: Protect employees and drivers from injuries and damages resulting from road accidents.`
            },
            {
              type: `li`,
              text: `Promote Safety: Promote road safety through education and awareness.`
            },
            {
              type: `p`,
              text: `Procedures:`
            },
            {
              type: `li`,
              text: `Vehicle Inspection: Vehicles must be inspected before each trip to ensure they are in good condition.`
            },
            {
              type: `li`,
              text: `Seatbelt Use: Seatbelts must be worn at all times while driving.`
            },
            {
              type: `li`,
              text: `Safe Driving: Drivers must drive safely and follow traffic rules.`
            },
            {
              type: `li`,
              text: `Mobile Phone Use: Mobile phones must not be used while driving.`
            },
            {
              type: `li`,
              text: `Rest Breaks: Regular rest breaks must be taken during long drives.`
            },
            {
              type: `p`,
              text: `Responsibilities:`
            },
            {
              type: `li`,
              text: `Management: Management is responsible for ensuring this policy is implemented.`
            },
            {
              type: `li`,
              text: `Drivers: Drivers are responsible for driving safely and following this policy.`
            },
            {
              type: `li`,
              text: `Employees: Employees are responsible for following this policy and reporting any breaches.`
            },
            {
              type: `p`,
              text: `Penalties: Penalties will be applied to anyone who breaches this policy.`
            },
            {
              type: `p`,
              text: `Evaluation and Review:This policy will be evaluated and reviewed periodically to ensure it remains effective and relevant.`
            },
            {
              type: `p`,
              text: `Approval: This policy has been approved by the organization's senior management.`
            },
            {
              type: `p`,
              text: `Date: 25. 1 2015 This policy was issued on 25.1.2025.`
            },
            {
              type: `p`,
              text: `Duration: This policy remains in effect until it is cancelled or amended. Organization Driving Security and Safety Policy`
            }
          ]
        },
        {
          id: `security-procedures`,
          title: `security procedures`,
          items: [
            {
              type: `p`,
              text: `بسم الله الرحمن الرحيم`
            },
            {
              type: `p`,
              text: `منظمة الخلد للاعمار والتنمية`
            },
            {
              type: `p`,
              text: `AL-KHOLD ORGNIZATION FOR 
RECONSTRACTION and DEVELOPMENT`
            },
            {
              type: `p`,
              text: `Security Procedures`
            },
            {
              type: `p`,
              text: `Introduction:`
            },
            {
              type: `p`,
              text: `These security procedures outline the measures to be taken to ensure the safety and security of our organization's staff, assets, and facilities. The procedures are designed to prevent, detect, and respond to security incidents, and to minimize the risk of harm to individuals and damage to property.`
            },
            {
              type: `p`,
              text: `Scope:`
            },
            {
              type: `p`,
              text: `These procedures apply to all staff, including employees, consultants, and volunteers, as well as visitors, partners, and other individuals who may be present on our premises or involved in our activities.`
            },
            {
              type: `p`,
              text: `Security Policies:`
            },
            {
              type: `li`,
              text: `Access Control: Access to our premises will be restricted to authorized individuals only.`
            },
            {
              type: `li`,
              text: `Confidentiality: Confidential information will be protected from unauthorized access, disclosure, or theft procedures.`
            },
            {
              type: `li`,
              text: `Physical Security: Our premises will be secured with physical barriers, locks, and alarms to prevent unauthorized access.`
            },
            {
              type: `li`,
              text: `Incident Response: We will have a plan in place to respond to security incidents, including emergencies, breaches, and other incidents.`
            },
            {
              type: `p`,
              text: `Security Procedures:`
            },
            {
              type: `li`,
              text: `Access Control Procedures: Staff will be issued with identification cards and will be required to use them to access our premises.`
            },
            {
              type: `li`,
              text: `Visitor Management: Visitors will be required to sign in and out, and will be escorted by a staff member while on our premises.`
            },
            {
              type: `li`,
              text: `Incident Reporting: All security incidents will be reported to management and investigated promptly.`
            },
            {
              type: `li`,
              text: `Emergency Response: We will have a plan in place to respond to emergencies, including fire, earthquake, and other disasters.`
            },
            {
              type: `li`,
              text: `Data Protection: Sensitive information will be protected from unauthorized access, disclosure, or theft procedures.`
            },
            {
              type: `p`,
              text: `Roles and Responsibilities:`
            },
            {
              type: `li`,
              text: `Management: Management is responsible for ensuring that these procedures are implemented and enforced.`
            },
            {
              type: `li`,
              text: `Security Team: The security team is responsible for implementing and enforcing these procedures, and for responding to security incidents.`
            },
            {
              type: `li`,
              text: `Staff: Staff are responsible for adhering to these procedures and reporting any security incidents or concerns.`
            },
            {
              type: `p`,
              text: `Monitoring and Evaluation:`
            },
            {
              type: `p`,
              text: `We will monitor and evaluate the implementation of these procedures regularly, and make necessary adjustments to ensure effectiveness.`
            },
            {
              type: `p`,
              text: `Conclusion:`
            },
            {
              type: `p`,
              text: `These security procedures outline the measures to be taken to ensure the safety and security of our organization's staff, assets, and facilities. It is essential that all staff are aware of and comply with these procedures to prevent, detect, and respond to security incidents.`
            }
          ]
        },
        {
          id: `personnel-security-procedure`,
          title: `Personnel security procedure`,
          items: [
            {
              type: `p`,
              text: `بسم الله الرحمن الرحيم`
            },
            {
              type: `p`,
              text: `منظمة الخلد للاعمار والتنمية`
            },
            {
              type: `p`,
              text: `AL-KHOLD ORGNIZATION FOR 
RECONSTRACTION and DEVELOPMENT`
            },
            {
              type: `p`,
              text: `Personnel security procedure`
            },
            {
              type: `p`,
              text: `Purpose`
            },
            {
              type: `p`,
              text: `To protect sensitive information and resources from unauthorized access  or misuse by employees or individual working within the organization.`
            },
            {
              type: `p`,
              text: `Scope:`
            },
            {
              type: `p`,
              text: `These procedures apply to all employees and individual working within the organization.`
            },
            {
              type: `p`,
              text: `Polices:`
            },
            {
              type: `li`,
              text: `Personnel Screening: Employees will be screened prior to hiring to ensure they are trustworthy.`
            },
            {
              type: `li`,
              text: `Employees training: employee will be trained on personnel security procedures and security policies.`
            },
            {
              type: `li`,
              text: `Access to Information: Access to information will be determined based on need to know.`
            },
            {
              type: `li`,
              text: `Employee Monitoring: employee will be monitored to insure they are following Personnel security procedure.`
            },
            {
              type: `li`,
              text: `Incident Reporting: security incidents will be reported and investigated.`
            },
            {
              type: `li`,
              text: `Security policies: clear security policies will be established and made available to employees`
            },
            {
              type: `li`,
              text: `Evaluation and review: Personnel security procedures will be evaluated and reviewed regularly.`
            },
            {
              type: `p`,
              text: `Procedures:`
            },
            {
              type: `li`,
              text: `Personnel Screening: Employees will be screened prior to hiring to ensure they are trustworthy.`
            },
            {
              type: `li`,
              text: `Comprehensive background check will be conducted, including verification of identity and criminal history.`
            },
            {
              type: `li`,
              text: `Employees training: employee will be trained on personnel security procedures and security policies.`
            },
            {
              type: `li`,
              text: `Regular training will be provided to employees on the latest security threats.`
            },
            {
              type: `li`,
              text: `Access to Information: Access to information will be determined based on need to know.`
            },
            {
              type: `li`,
              text: `Accessed to sensitive information will only be granted to employee who requires it to perform their job functions.`
            },
            {
              type: `li`,
              text: `Employee Monitoring: employee will be monitored to insure they are following Personnel security procedure.`
            },
            {
              type: `li`,
              text: `Monitoring tools such as software and cameras. Will be used to monitor employees.`
            },
            {
              type: `li`,
              text: `Incident Reporting: security incidents will be reported and investigated.`
            },
            {
              type: `li`,
              text: `Action will be taken to prevent future security incidence.`
            },
            {
              type: `li`,
              text: `Security policies: clear security policies will be established and made available to employees.`
            },
            {
              type: `li`,
              text: `Security policies will be updated by regularly to reflect new security threats.`
            },
            {
              type: `li`,
              text: `Evaluation and review: Personnel security procedures will be evaluated and reviewed regularly.`
            },
            {
              type: `li`,
              text: `Personnel Screening: Employees will be screened prior to hiring to ensure they are trustworthy.`
            },
            {
              type: `li`,
              text: `Employees training: employee will be trained on personnel security procedures and security policies.`
            },
            {
              type: `li`,
              text: `Access to Information: Access to information will be determined based on need to know.`
            },
            {
              type: `li`,
              text: `Employee Monitoring: employee will be monitored to insure they are following Personnel security procedure.`
            },
            {
              type: `li`,
              text: `Incident Reporting: security incidents will be reported and investigated.`
            },
            {
              type: `li`,
              text: `Security policies: clear security policies will be established and made available to employees`
            },
            {
              type: `li`,
              text: `Evaluation and review: Personnel security procedures will be evaluated and reviewed regularly.`
            },
            {
              type: `li`,
              text: `Action will be taken to improve Personnel security procedure.`
            },
            {
              type: `p`,
              text: `Signature:`
            },
            {
              type: `p`,
              text: `Name: Mr. Hassan Mohammed A.Alkarim Ahmed`
            },
            {
              type: `p`,
              text: `Title: General manager.`
            }
          ]
        }
      ]
    },
    {
      title: `Procurement & Finance`,
      slug: `procurement-finance`,
      docs: [
        {
          id: `procurement-regulations`,
          title: `Procurement Regulations`,
          items: [
            {
              type: `p`,
              text: `بسم الله الرحمن الرحيم`
            },
            {
              type: `p`,
              text: `منظمة الخلد للاعمار والتنمية`
            },
            {
              type: `p`,
              text: `AL-KHOLD ORGNIZATION FOR 
RECONSTRACTION and DEVELOPMENT`
            },
            {
              type: `p`,
              text: `Procurement Regulations`
            },
            {
              type: `p`,
              text: `Introduction:`
            },
            {
              type: `p`,
              text: `These procurement regulations outline the policies and procedures for the procurement of goods, services, and works for our organization. The regulations are designed to ensure that procurement is conducted in a fair, transparent, and competitive manner.`
            },
            {
              type: `p`,
              text: `Scope:`
            },
            {
              type: `p`,
              text: `These regulations apply to all procurement activities undertaken by Al organization, including the procurement of goods, services, and works.`
            },
            {
              type: `p`,
              text: `Procurement Principles:`
            },
            {
              type: `li`,
              text: `Fairness: Procurement will be conducted in a fair and impartial manner.`
            },
            {
              type: `li`,
              text: `Transparency: Procurement processes will be transparent and open to competition.`
            },
            {
              type: `li`,
              text: `Value for Money: Procurement will be conducted to achieve value for money.`
            },
            {
              type: `li`,
              text: `Accountability: Procurement decisions will be accountable and subject to review.`
            },
            {
              type: `p`,
              text: `Procurement Procedures:`
            },
            {
              type: `li`,
              text: `Procurement Planning: Procurement planning will be conducted to identify procurement needs and develop procurement strategies.`
            },
            {
              type: `li`,
              text: `Tendering: Tendering will be conducted in accordance with these regulations.`
            },
            {
              type: `li`,
              text: `Evaluation: Tenders will be evaluated in accordance with the evaluation criteria set out in the tender documents.`
            },
            {
              type: `li`,
              text: `Contract Award: Contracts will be awarded to the successful tenderer.`
            },
            {
              type: `p`,
              text: `Procurement Methods:`
            },
            {
              type: `li`,
              text: `Open Tendering: Open tendering will be the default procurement method.`
            },
            {
              type: `li`,
              text: `Restricted Tendering: Restricted tendering may be used in certain circumstances.`
            },
            {
              type: `li`,
              text: `Single Source Procurement: Single source procurement may be used in certain circumstances.`
            },
            {
              type: `p`,
              text: `Roles and Responsibilities:`
            },
            {
              type: `li`,
              text: `Procurement Committee: The procurement committee will oversee the procurement process.`
            },
            {
              type: `li`,
              text: `Procurement Officer: The procurement officer will manage the procurement process.`
            },
            {
              type: `li`,
              text: `Evaluation Committee: The evaluation committee will evaluate tenders.`
            },
            {
              type: `p`,
              text: `Best Practices:`
            },
            {
              type: `li`,
              text: `Competition: Encourage competition in procurement.`
            },
            {
              type: `li`,
              text: `Transparency: Ensure transparency in procurement processes.`
            },
            {
              type: `li`,
              text: `Accountability: Ensure accountability in procurement decisions.`
            },
            {
              type: `li`,
              text: `Value for Money: Achieve value for money in procurement.`
            },
            {
              type: `p`,
              text: `Procurement Thresholds:`
            },
            {
              type: `li`,
              text: `Low Value Procurement: Low value procurement will be subject to simplified procurement procedures.`
            },
            {
              type: `li`,
              text: `Medium Value Procurement: Medium value procurement will be subject to standard procurement procedures.`
            },
            {
              type: `li`,
              text: `High Value Procurement: High value procurement will be subject to enhanced procurement procedures.`
            },
            {
              type: `p`,
              text: `Procurement Records:`
            },
            {
              type: `li`,
              text: `Procurement Files: Procurement files will be maintained for all procurement activities.`
            },
            {
              type: `li`,
              text: `Procurement Records: Procurement records will be retained for a minimum of 5 years.`
            },
            {
              type: `p`,
              text: `Conclusion:`
            },
            {
              type: `p`,
              text: `These procurement regulations outline the policies and procedures for the procurement of goods, services, and works for our organization. They are designed to ensure that procurement is conducted in a fair, transparent, and competitive manner.`
            }
          ]
        }
      ]
    },
    {
      title: `Logistics & Fleet`,
      slug: `logistics-fleet`,
      docs: [
        {
          id: `managing-stocks-and-warehouse-policies`,
          title: `Managing Stocks and Warehouse Policies`,
          items: [
            {
              type: `p`,
              text: `بسم الله الرحمن الرحيم`
            },
            {
              type: `p`,
              text: `منظمة الخلد للاعمار والتنمية`
            },
            {
              type: `p`,
              text: `AL-KHOLD ORGNIZATION FOR 
RECONSTRACTION and DEVELOPMENT`
            },
            {
              type: `p`,
              text: `Managing Stocks and Warehouse Policies`
            },
            {
              type: `p`,
              text: `Introduction:`
            },
            {
              type: `p`,
              text: `Effective management of stocks and warehouses is crucial for any organization. This policy outlines the principles and procedures for managing stocks and warehouses in an efficient and effective manner.`
            },
            {
              type: `p`,
              text: `Scope:`
            },
            {
              type: `p`,
              text: `This policy applies to all stocks and warehouses managed by the organization.`
            },
            {
              type: `p`,
              text: `Objectives:`
            },
            {
              type: `li`,
              text: `Ensure Stock Availability: Ensure that stocks are available to meet customer demands.`
            },
            {
              type: `li`,
              text: `Minimize Costs: Minimize costs associated with stockholding and warehousing.`
            },
            {
              type: `li`,
              text: `Improve Efficiency: Improve the efficiency of warehouse and stock management operations`
            },
            {
              type: `li`,
              text: `Ensure Quality: Ensure the quality of stocks and warehouse operations.`
            },
            {
              type: `p`,
              text: `Policies:`
            },
            {
              type: `li`,
              text: `Stockholding Policy: The organization will maintain an optimal level of stockholding to meet customer demands.`
            },
            {
              type: `li`,
              text: `Warehousing Policy: The organization will ensure that warehouses are managed in a safe, secure, and efficient manner.`
            },
            {
              type: `li`,
              text: `Stock Management Policy: The organization will implement effective stock management procedures to ensure accurate stock levels.`
            },
            {
              type: `li`,
              text: `Inventory Control Policy: The organization will implement inventory control procedures to prevent stock losses and inaccuracies.`
            },
            {
              type: `p`,
              text: `Procedures:`
            },
            {
              type: `li`,
              text: `Receiving Stocks: Stocks will be received and checked against purchase orders and invoices`
            },
            {
              type: `li`,
              text: `Stock Storage: Stocks will be stored in designated areas within the warehouse.`
            },
            {
              type: `li`,
              text: `Stock Issuance: Stocks will be issued to customers or for internal use based on approved requisitions.`
            },
            {
              type: `li`,
              text: `Stock Counting: Regular stock counts will be conducted to ensure accuracy of stock records.`
            },
            {
              type: `li`,
              text: `. Stock Replenishment: Stocks will be replenished based on minimum and maximum stock levels.`
            },
            {
              type: `p`,
              text: `Responsibilities:`
            },
            {
              type: `li`,
              text: `Warehouse Manager: The Warehouse Manager is responsible for managing the warehouse and stock operations`
            },
            {
              type: `li`,
              text: `Stock Controllers: Stock Controllers are responsible for managing stock levels and ensuring accurate stock records.`
            },
            {
              type: `li`,
              text: `Inventory Team: The Inventory Team is responsible for conducting regular stock counts and reconciliations.`
            },
            {
              type: `p`,
              text: `Conclusion:`
            },
            {
              type: `p`,
              text: `Effective management of stocks and warehouses is crucial for the success of the organization. This policy outlines the principles and procedures for managing stocks and warehouses in an efficient and effective manner.`
            }
          ]
        },
        {
          id: `vehicle-maintenance-program`,
          title: `Vehicle Maintenance Program`,
          items: [
            {
              type: `p`,
              text: `بسم الله الرحمن الرحيم`
            },
            {
              type: `p`,
              text: `منظمة الخلد للاعمار والتنمية`
            },
            {
              type: `p`,
              text: `AL-KHOLD ORGNIZATION FOR 
RECONSTRACTION and DEVELOPMENT`
            },
            {
              type: `p`,
              text: `Vehicle Maintenance Program for Al-Khold Organization for Reconstruction and Development`
            },
            {
              type: `p`,
              text: `Introduction:`
            },
            {
              type: `p`,
              text: `As a responsible organization, we recognize the importance of maintaining our vehicles in good working condition to ensure the safety of our employees, prevent accidents, and reduce operating costs. This Vehicle Maintenance Program is designed to provide a systematic approach to maintaining our vehicles and ensuring they are in good working condition.`
            },
            {
              type: `p`,
              text: `Objectives:`
            },
            {
              type: `li`,
              text: `Ensure Vehicle Safety: Ensure that all vehicles are in a safe and roadworthy condition.`
            },
            {
              type: `li`,
              text: `Reduce Maintenance Costs: Reduce maintenance costs by identifying and addressing potential problems before they become major issues.`
            },
            {
              type: `li`,
              text: `Improve Vehicle Availability: Improve vehicle availability by minimizing downtime and ensuring that vehicles are available when needed.`
            },
            {
              type: `li`,
              text: `Comply with Regulations: Comply with all relevant laws and regulations related to vehicle maintenance.`
            },
            {
              type: `p`,
              text: `Scope:`
            },
            {
              type: `p`,
              text: `This program applies to all vehicles owned, leased, or operated by for Al-Khold Organization for Reconstruction and Development.`
            },
            {
              type: `p`,
              text: `Maintenance Schedule:`
            },
            {
              type: `li`,
              text: `Daily Checks: Drivers will conduct daily checks on their vehicles to ensure they are in good working condition.`
            },
            {
              type: `li`,
              text: `Weekly Checks: Fleet Manager will conduct weekly checks on all vehicles to ensure they are in good working condition.`
            },
            {
              type: `li`,
              text: `Monthly Checks: Maintenance personnel will conduct monthly checks on all vehicles to ensure they are in good working condition.`
            },
            {
              type: `li`,
              text: `Scheduled Maintenance: Vehicles will be scheduled for maintenance at regular intervals every 5,000 miles or 6 months ( which come first)`
            },
            {
              type: `li`,
              text: `Unscheduled Maintenance: Vehicles will be repaired as needed to address any issues that arise between scheduled maintenance intervals.`
            },
            {
              type: `p`,
              text: `Maintenance Activities:`
            },
            {
              type: `li`,
              text: `Oil Changes: Oil changes will be performed at regular intervals every 5,000 miles`
            },
            {
              type: `li`,
              text: `Tire Rotations: Tire rotations will be performed at regular intervals every 10,000`
            },
            {
              type: `li`,
              text: `Brake Inspections: Brake inspections will be performed at regular intervals every 10,000 miles or 12 months`
            },
            {
              type: `li`,
              text: `Battery Checks: Battery checks will be performed at regular intervals (e.g., every 6 months`
            },
            {
              type: `li`,
              text: `Other Maintenance: Other maintenance activities will be performed as needed (e.g., repairs, replacements, etc.`
            },
            {
              type: `p`,
              text: `Responsibilities:`
            },
            {
              type: `li`,
              text: `Fleet Manager: The Fleet Manager is responsible for managing the vehicle maintenance program.`
            },
            {
              type: `li`,
              text: `Drivers: Drivers are responsible for conducting daily checks on their vehicles and reporting any issues to the Fleet Manager..`
            },
            {
              type: `li`,
              text: `Maintenance Personnel: Maintenance personnel are responsible for performing scheduled and unscheduled maintenance on vehicles.`
            },
            {
              type: `p`,
              text: `Record Keeping:`
            },
            {
              type: `li`,
              text: `Maintenance Records: Maintenance records will be kept for all vehicles, including oil changes, tire rotations, brake inspections, and other maintenance activities.`
            },
            {
              type: `li`,
              text: `Repair Records: Repair records will be kept for all vehicles, including repairs, replacements, and other maintenance activities.`
            },
            {
              type: `p`,
              text: `Conclusion:`
            },
            {
              type: `p`,
              text: `The Vehicle Maintenance Program is designed to ensure that our vehicles are in good working condition and meet all relevant safety and regulatory requirements. We are committed to maintaining our vehicles in a safe and efficient manner to ensure the safety of our employees and reduce operating costs.`
            }
          ]
        }
      ]
    }
  ]
};
